<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800"
      content-class="fts-dialog"
      scrollable
      :retain-focus="false"
    >
      <v-stepper
        v-if="!showWhatsapp"
        v-model="e1"
        class="modern-stepper"
        elevation="0"
      >
        <v-stepper-header class="modern-stepper-header">
          <v-stepper-step :complete="e1 > 1" step="1" color="primary">
            <span class="step-label">Welcome</span>
          </v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2" color="primary">
            <span class="step-label">Countries</span>
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3" color="primary">
            <span class="step-label">Choose Setup</span>
          </v-stepper-step>
          <v-divider></v-divider>

          <!-- Dynamic steps based on calling type -->
          <template v-if="selectedCallingType === 'cloud'">
            <v-stepper-step :complete="e1 > 4" step="4" color="primary">
              <span class="step-label">Provider</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 5" step="5" color="primary">
              <span class="step-label">Configure</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              v-if="cloudProviderType === 'twilio'"
              :complete="e1 > 6"
              step="6"
              color="primary"
            >
              <span class="step-label">SIP Trunk</span>
            </v-stepper-step>
            <v-divider v-if="cloudProviderType === 'twilio'"></v-divider>
            <v-stepper-step
              v-if="cloudProviderType === 'twilio'"
              :complete="e1 > 7"
              step="7"
              color="primary"
            >
              <span class="step-label">Phone Numbers</span>
            </v-stepper-step>
            <v-divider v-if="cloudProviderType === 'twilio'"></v-divider>
            <v-stepper-step
              :complete="contactAdded"
              :step="cloudProviderType === 'twilio' ? 8 : 6"
              color="primary"
            >
              <span class="step-label">Add Contact</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="cloudFirstCallMade"
              :step="cloudProviderType === 'twilio' ? 9 : 7"
              color="primary"
            >
              <span class="step-label">First Call</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :step="cloudProviderType === 'twilio' ? 10 : 8"
              color="primary"
            >
              <span class="step-label">Finish</span>
            </v-stepper-step>
          </template>

          <template v-else>
            <v-stepper-step :complete="contactAdded" step="4" color="primary">
              <span class="step-label">Add Contact</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="5" :complete="e1 > 5" color="primary">
              <span class="step-label">First Call</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="6" color="primary">
              <span class="step-label">Finish</span>
            </v-stepper-step>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <!-- Step 1: Welcome -->
          <v-stepper-content step="1">
            <v-card flat class="welcome-card">
              <v-card-text class="pa-5">
                <v-row align="center">
                  <v-col cols="12" md="7">
                    <div class="welcome-content">
                      <h1 class="modern-h1 mb-4">
                        Hey {{ getFirstName() }}! 👋
                      </h1>
                      <p class="modern-p mb-4">
                        Welcome to <strong>GoDial</strong>. My name is Avijit, I
                        am the founder of GoDial. I would like to personally
                        welcome you aboard.
                      </p>
                      <p class="modern-p mb-4">
                        With GoDial you can easily setup your call center,
                        integrate with Facebook, connect Business WhatsApp,
                        record calls, monitor team's performance and lot more.
                      </p>
                      <div
                        class="feature-chips mt-3"
                        style="display: flex; flex-wrap: wrap; gap: 6px;"
                      >
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-phone-outgoing</v-icon>
                          Autodialer
                        </v-chip>
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-account-box</v-icon>
                          CRM
                        </v-chip>
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-record-circle</v-icon>
                          Call Recording
                        </v-chip>
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-whatsapp</v-icon>
                          Whatsapp
                        </v-chip>
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-facebook</v-icon>
                          Facebook
                        </v-chip>
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-connection</v-icon>
                          Integrations
                        </v-chip>
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-cloud-outline</v-icon>
                          Cloud VOIP Dialer
                        </v-chip>
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-sim</v-icon>
                          SIM based Dialer
                        </v-chip>
                        <v-chip color="#37cf37" text-color="white" small label>
                          <v-icon small left>mdi-chart-line</v-icon>
                          Analytics
                        </v-chip>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="5" class="text-center">
                    <v-avatar size="200" class="avatar-shadow">
                      <img src="../assets/avijit.jpg" alt="Avijit Sarkar" />
                    </v-avatar>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  large
                  depressed
                  class="px-8 text-capitalize"
                  @click="e1 = 2"
                >
                  Let's get started!
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <!-- Step 2: Country Selection -->
          <v-stepper-content step="2">
            <v-card flat class="choice-card">
              <v-card-text class="pa-5">
                <div class="text-center mb-6">
                  <h1 class="modern-h1 mb-3">Where are you calling?</h1>
                  <p class="modern-p">
                    Help us understand your calling needs to recommend the best
                    setup
                  </p>
                </div>

                <v-row class="mt-6" justify="center">
                  <v-col cols="12" md="5">
                    <v-card elevation="2" class="pa-4 country-select-card">
                      <div class="text-center mb-3">
                        <v-icon size="40" color="primary"
                          >mdi-phone-outgoing</v-icon
                        >
                        <h3 class="mt-2 option-title">Calling From</h3>
                        <p class="caption grey--text">
                          Where is your team located?
                        </p>
                      </div>
                      <v-autocomplete
                        v-model="callingFromCountry"
                        :items="countryList"
                        item-text="name"
                        item-value="code"
                        label="Select Country"
                        outlined
                        dense
                        hide-details="auto"
                        class="country-autocomplete"
                      >
                      </v-autocomplete>
                    </v-card>
                  </v-col>

                  <v-col
                    cols="12"
                    md="1"
                    class="d-flex align-center justify-center"
                  >
                    <v-icon size="32" color="grey lighten-1"
                      >mdi-arrow-right</v-icon
                    >
                  </v-col>

                  <v-col cols="12" md="5">
                    <v-card elevation="2" class="pa-4 country-select-card">
                      <div class="text-center mb-3">
                        <v-icon size="40" color="primary"
                          >mdi-phone-incoming</v-icon
                        >
                        <h3 class="mt-2 option-title">Calling To</h3>
                        <p class="caption grey--text">
                          Where are your customers?
                        </p>
                      </div>
                      <v-autocomplete
                        v-model="callingToCountry"
                        :items="countryList"
                        item-text="name"
                        item-value="code"
                        label="Select Country"
                        outlined
                        dense
                        hide-details="auto"
                        class="country-autocomplete"
                      >
                      </v-autocomplete>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions class="pa-4">
                <v-btn text class="text-capitalize" @click="e1 = 1">
                  <v-icon left>mdi-arrow-left</v-icon>
                  Back
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  large
                  depressed
                  :disabled="!callingFromCountry || !callingToCountry"
                  class="px-8 text-capitalize"
                  @click="e1 = 3"
                >
                  Continue
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <!-- Step 3: Choose Calling Type -->
          <v-stepper-content step="3">
            <v-card flat class="choice-card">
              <v-card-text class="pa-5">
                <div class="text-center mb-6">
                  <h1 class="modern-h1 mb-3">How do you want to call?</h1>
                  <p class="modern-p">
                    Choose your preferred calling method to get started
                  </p>
                </div>

                <v-row class="mt-3">
                  <v-col cols="12" md="6">
                    <v-card
                      :outlined="selectedCallingType !== 'sim'"
                      :class="[
                        'calling-option-card',
                        { 'selected-card': selectedCallingType === 'sim' },
                      ]"
                      elevation="2"
                      hover
                      style="position: relative"
                      @click="selectedCallingType = 'sim'"
                    >
                      <!-- Recommended chip in top right corner -->
                      <v-chip
                        v-if="isSameCountryCalling"
                        x-small
                        color="success"
                        text-color="white"
                        class="recommended-chip-corner"
                      >
                        <v-icon x-small left>mdi-check-circle</v-icon>
                        Recommended
                      </v-chip>
                      <v-card-text class="pa-4 text-center">
                        <div class="option-icon-wrapper mb-2">
                          <v-icon
                            size="48"
                            :color="
                              selectedCallingType === 'sim' ? 'primary' : 'grey'
                            "
                          >
                            mdi-sim
                          </v-icon>
                        </div>
                        <h3 class="option-title mb-2">SIM Based Calling</h3>
                        <v-chip
                          x-small
                          color="blue lighten-4"
                          text-color="blue darken-2"
                          class="mb-2"
                        >
                          Recommended for Mobile Teams
                        </v-chip>
                        <p
                          class="option-description mb-2"
                          style="font-size: 13px; line-height: 1.4;"
                        >
                          Use your existing smartphones and your own SIM card to
                          place calls. Perfect for teams already using mobile
                          devices.
                        </p>
                        <v-list
                          dense
                          class="mt-2 transparent"
                          style="padding: 0;"
                        >
                          <v-list-item dense>
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="success">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="feature-text"
                                >No KYC</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item dense>
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="success">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="feature-text"
                                >Instant Setup</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item dense>
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="success">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="feature-text"
                                >Unlimited Calling</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item dense>
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="success">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="feature-text"
                                >Use existing phone</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-card
                      :outlined="selectedCallingType !== 'cloud'"
                      :class="[
                        'calling-option-card',
                        { 'selected-card': selectedCallingType === 'cloud' },
                      ]"
                      elevation="2"
                      hover
                      style="position: relative"
                      @click="selectedCallingType = 'cloud'"
                    >
                      <!-- Recommended chip in top right corner -->
                      <v-chip
                        v-if="isInternationalCalling"
                        x-small
                        color="success"
                        text-color="white"
                        class="recommended-chip-corner"
                      >
                        <v-icon x-small left>mdi-check-circle</v-icon>
                        Recommended
                      </v-chip>
                      <v-card-text class="pa-4 text-center">
                        <div class="option-icon-wrapper mb-2">
                          <v-icon
                            size="48"
                            :color="
                              selectedCallingType === 'cloud'
                                ? 'primary'
                                : 'grey'
                            "
                          >
                            mdi-cloud-outline
                          </v-icon>
                        </div>
                        <h3 class="option-title mb-2">Cloud Based Calling</h3>
                        <v-chip
                          x-small
                          color="purple lighten-4"
                          text-color="purple darken-2"
                          class="mb-2"
                        >
                          Professional Setup
                        </v-chip>
                        <p
                          class="option-description mb-2"
                          style="font-size: 13px; line-height: 1.4;"
                        >
                          Use your own carrier to setup your call center. Handle
                          incoming and outgoing calls seamlessly.
                        </p>
                        <v-list
                          dense
                          class="mt-2 transparent"
                          style="padding: 0;"
                        >
                          <v-list-item dense>
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="success">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="feature-text"
                                >Browser based desktop
                                calling</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item dense>
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="success">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="feature-text"
                                >Call any country</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item dense>
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="success">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="feature-text"
                                >Call Recording</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item dense>
                            <v-list-item-icon class="mr-2">
                              <v-icon small color="success">mdi-check</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="feature-text"
                                >Bring your own carrier</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions class="pa-4">
                <v-btn text class="text-capitalize" @click="e1 = 2">
                  <v-icon left>mdi-arrow-left</v-icon>
                  Back
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  large
                  depressed
                  :disabled="!selectedCallingType"
                  class="px-8 text-capitalize"
                  @click="handleCallingTypeSelection"
                >
                  Continue
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <!-- Step 4: Cloud Provider Selection (Cloud) / Add Contact (SIM) -->
          <v-stepper-content step="4">
            <!-- For Cloud: Provider Selection -->
            <template v-if="selectedCallingType === 'cloud'">
              <v-card flat class="choice-card">
                <v-card-text class="pa-5">
                  <div class="text-center mb-6">
                    <h1 class="modern-h1 mb-3">Choose your SIP carrier</h1>
                    <p class="modern-p">
                      GoDial works with your own SIP provider for calling
                    </p>
                  </div>

                  <v-row class="mt-6">
                    <v-col cols="12" md="6">
                      <v-card
                        :outlined="cloudProviderType !== 'twilio'"
                        :class="[
                          'calling-option-card',
                          { 'selected-card': cloudProviderType === 'twilio' },
                        ]"
                        elevation="2"
                        hover
                        style="position: relative"
                        @click="cloudProviderType = 'twilio'"
                      >
                        <!-- Recommended chip in top left corner -->
                        <v-chip
                          x-small
                          color="success"
                          text-color="white"
                          class="recommended-chip-corner"
                        >
                          <v-icon x-small left>mdi-check-circle</v-icon>
                          Recommended
                        </v-chip>
                        <v-card-text class="pa-6 text-center">
                          <div class="option-icon-wrapper mb-4">
                            <img
                              src="https://upload.wikimedia.org/wikipedia/commons/7/7e/Twilio-logo-red.svg"
                              height="64"
                              alt="Twilio"
                              style="opacity: 0.8"
                              :style="{
                                opacity:
                                  cloudProviderType === 'twilio' ? 1 : 0.6,
                              }"
                            />
                          </div>
                          <h3 class="option-title mb-3">Connect with Twilio</h3>
                          <p class="option-description mb-4">
                            Quickly connect your existing Twilio account or
                            create a new one. Automatic configuration with
                            OAuth.
                          </p>
                          <v-chip
                            small
                            :color="
                              cloudProviderType === 'twilio'
                                ? 'primary'
                                : 'grey lighten-2'
                            "
                            :text-color="
                              cloudProviderType === 'twilio'
                                ? 'white'
                                : 'grey darken-1'
                            "
                          >
                            <v-icon x-small left>mdi-flash</v-icon>
                            Quick Setup
                          </v-chip>
                          <v-list dense class="mt-4 transparent">
                            <v-list-item dense>
                              <v-list-item-icon class="mr-2">
                                <v-icon small color="success">mdi-check</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="feature-text"
                                  >One-click authentication</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense>
                              <v-list-item-icon class="mr-2">
                                <v-icon small color="success">mdi-check</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="feature-text"
                                  >Auto-fetch account details</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense>
                              <v-list-item-icon class="mr-2">
                                <v-icon small color="success">mdi-check</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="feature-text"
                                  >Global phone numbers</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-card
                        :outlined="cloudProviderType !== 'own'"
                        :class="[
                          'calling-option-card',
                          { 'selected-card': cloudProviderType === 'own' },
                        ]"
                        elevation="2"
                        hover
                        @click="cloudProviderType = 'own'"
                      >
                        <v-card-text class="pa-6 text-center">
                          <div class="option-icon-wrapper mb-4">
                            <v-icon
                              size="64"
                              :color="
                                cloudProviderType === 'own' ? 'primary' : 'grey'
                              "
                            >
                              mdi-server-network
                            </v-icon>
                          </div>
                          <h3 class="option-title mb-3">
                            Your Own SIP Provider
                          </h3>
                          <p class="option-description mb-4">
                            Connect any SIP trunk provider of your choice. Full
                            control over your telephony setup.
                          </p>
                          <v-chip
                            small
                            :color="
                              cloudProviderType === 'own'
                                ? 'primary'
                                : 'grey lighten-2'
                            "
                            :text-color="
                              cloudProviderType === 'own'
                                ? 'white'
                                : 'grey darken-1'
                            "
                          >
                            <v-icon x-small left>mdi-cog</v-icon>
                            Custom Setup
                          </v-chip>
                          <v-list dense class="mt-4 transparent">
                            <v-list-item dense>
                              <v-list-item-icon class="mr-2">
                                <v-icon small color="success">mdi-check</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="feature-text"
                                  >Any SIP provider</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense>
                              <v-list-item-icon class="mr-2">
                                <v-icon small color="success">mdi-check</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="feature-text"
                                  >Full configuration control</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense>
                              <v-list-item-icon class="mr-2">
                                <v-icon small color="success">mdi-check</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="feature-text"
                                  >Existing provider support</v-list-item-title
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn text class="text-capitalize" @click="e1 = 3">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    class="px-8 text-capitalize"
                    :disabled="!cloudProviderType"
                    @click="e1 = 5"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <!-- For SIM: Add Contact -->
            <template v-else>
              <v-card flat class="contact-card">
                <v-card-text class="pa-5">
                  <v-row>
                    <v-col cols="12" md="7">
                      <div class="content-section">
                        <h1 class="modern-h1 mb-4">Your First Contact</h1>
                        <p class="modern-p mb-4">
                          GoDial's CRM is made up of <strong>Lists</strong> and
                          each list is a set of contacts. Lists are assigned to
                          one or many Members.
                        </p>
                        <p class="modern-p mb-4">
                          For now, let's create a dummy contact for testing. We
                          will add this contact to your
                          <strong>Default list</strong> and assign it to you as
                          well.
                        </p>
                        <v-alert color="#37cf37" text dense class="mt-4">
                          <div class="d-flex align-center">
                            <v-icon color="#37cf37" class="mr-2"
                              >mdi-lightbulb-outline</v-icon
                            >
                            <span class="caption"
                              >You can import bulk contacts later from Excel or
                              CSV files</span
                            >
                          </div>
                        </v-alert>
                      </div>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-card elevation="3" class="modern-form-card">
                        <v-card-text class="pa-6">
                          <div class="text-center mb-4">
                            <v-avatar color="primary" size="60">
                              <v-icon size="30" color="white"
                                >mdi-account-plus</v-icon
                              >
                            </v-avatar>
                            <h3 class="mt-3 mb-2">Add Test Contact</h3>
                          </div>
                          <v-form v-model="valid">
                            <v-text-field
                              v-model="name"
                              :rules="nameRules"
                              label="Name"
                              required
                              placeholder="John Doe"
                              outlined
                              dense
                              hide-details="auto"
                              class="mb-4"
                            >
                              <template v-slot:prepend-inner>
                                <v-icon color="primary" size="20"
                                  >mdi-account</v-icon
                                >
                              </template>
                            </v-text-field>

                            <v-text-field
                              v-model="phone"
                              :rules="phoneRules"
                              label="Phone"
                              required
                              placeholder="+91 7044406666"
                              outlined
                              dense
                              hide-details="auto"
                              class="mb-4"
                            >
                              <template v-slot:prepend-inner>
                                <v-icon color="primary" size="20"
                                  >mdi-phone</v-icon
                                >
                              </template>
                            </v-text-field>

                            <v-btn
                              color="primary"
                              block
                              large
                              depressed
                              :disabled="contactAdded"
                              class="text-capitalize"
                              @click="addContact()"
                            >
                              <v-icon v-if="!contactAdded" left
                                >mdi-plus-circle</v-icon
                              >
                              <v-icon v-else left>mdi-check-circle</v-icon>
                              {{
                                contactAdded ? "Contact Added" : "Add Contact"
                              }}
                            </v-btn>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn text class="text-capitalize" @click="e1 = 3">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    class="px-8 text-capitalize"
                    @click="e1 = 5"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-stepper-content>

          <!-- Step 5: Cloud Setup (Cloud) / First Call (SIM) -->
          <v-stepper-content step="5">
            <!-- For Cloud: Twilio or Own Provider Setup -->
            <template v-if="selectedCallingType === 'cloud'">
              <v-card flat class="setup-card gradient-bg">
                <!-- Decorative Elements -->
                <div class="decorative-circle circle-1"></div>
                <div class="decorative-circle circle-2"></div>

                <v-card-text
                  class="pa-5"
                  style="position: relative; z-index: 1;"
                >
                  <!-- Twilio Setup -->
                  <div v-if="cloudProviderType === 'twilio'">
                    <div class="text-center mb-6">
                      <div class="step-badge mb-4">
                        <v-chip
                          color="primary"
                          small
                          outlined
                          class="font-weight-bold"
                        >
                          <v-icon x-small left>mdi-link-variant</v-icon>
                          STEP 4
                        </v-chip>
                      </div>
                      <h1 class="modern-h1 mb-3">
                        Connect Your Twilio Account
                      </h1>
                      <p class="modern-p">
                        Authenticate with Twilio to automatically configure your
                        cloud calling
                      </p>
                    </div>

                    <v-row justify="center">
                      <v-col cols="12" md="8">
                        <!-- Connected State -->
                        <v-card
                          v-if="twilioConnected"
                          elevation="3"
                          class="text-center pa-6"
                        >
                          <v-avatar color="success" size="80" class="mb-4">
                            <v-icon size="40" color="white"
                              >mdi-check-circle</v-icon
                            >
                          </v-avatar>
                          <h3 class="modern-h3 mb-2">Twilio Connected!</h3>
                          <p class="modern-p mb-4">
                            Your Twilio account has been successfully linked.
                          </p>
                          <v-chip
                            color="success"
                            text-color="white"
                            class="mb-4"
                          >
                            <v-icon small left>mdi-account-check</v-icon>
                            {{
                              twilioAccountInfo
                                ? twilioAccountInfo.friendlyName
                                : "Connected"
                            }}
                          </v-chip>
                          <p class="caption grey--text">
                            Account SID:
                            {{
                              twilioAccountInfo
                                ? twilioAccountInfo.accountSid.substring(
                                    0,
                                    10,
                                  ) + "..."
                                : ""
                            }}
                          </p>

                          <!-- Show connected phone numbers -->
                          <div
                            v-if="
                              twilioPhoneNumbers &&
                                twilioPhoneNumbers.length > 0
                            "
                            class="mt-4 text-center"
                          >
                            <v-divider class="mb-3"></v-divider>
                            <p class="subtitle-2 font-weight-bold mb-2">
                              <v-icon small color="success" class="mr-1"
                                >mdi-phone-check</v-icon
                              >
                              Your Phone Numbers ({{
                                twilioPhoneNumbers.length
                              }})
                            </p>
                            <div class="d-flex justify-center flex-wrap">
                              <v-chip
                                v-for="num in twilioPhoneNumbers"
                                :key="num.sid || num.phoneNumber"
                                small
                                color="success"
                                text-color="white"
                                class="ma-1"
                              >
                                <v-icon small left>mdi-phone</v-icon>
                                {{ num.phoneNumber }}
                              </v-chip>
                            </div>
                          </div>

                          <!-- Show SIP Domains if available -->
                          <div
                            v-if="
                              twilioSipDomains && twilioSipDomains.length > 0
                            "
                            class="mt-3 text-center"
                          >
                            <p class="subtitle-2 font-weight-bold mb-2">
                              <v-icon small color="primary" class="mr-1"
                                >mdi-server</v-icon
                              >
                              SIP Domains ({{ twilioSipDomains.length }})
                            </p>
                            <div class="d-flex justify-center flex-wrap">
                              <v-chip
                                v-for="domain in twilioSipDomains"
                                :key="domain.sid"
                                small
                                outlined
                                color="primary"
                                class="ma-1"
                              >
                                {{ domain.domainName }}
                              </v-chip>
                            </div>
                          </div>

                          <!-- Show Elastic SIP Trunks if available -->
                          <div
                            v-if="
                              twilioElasticTrunks &&
                                twilioElasticTrunks.length > 0
                            "
                            class="mt-3"
                          >
                            <p class="subtitle-2 font-weight-bold mb-2">
                              <v-icon small color="primary" class="mr-1"
                                >mdi-transit-connection-variant</v-icon
                              >
                              Elastic SIP Trunks ({{
                                twilioElasticTrunks.length
                              }})
                            </p>
                            <v-list dense class="text-left">
                              <v-list-item
                                v-for="trunk in twilioElasticTrunks"
                                :key="trunk.sid"
                                class="px-2"
                              >
                                <v-list-item-icon class="mr-2">
                                  <v-icon color="success" small
                                    >mdi-check-circle</v-icon
                                  >
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title class="subtitle-2">{{
                                    trunk.friendlyName
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle class="caption">
                                    Domain: {{ trunk.domainName }}
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle
                                    v-if="
                                      trunk.originationUrls &&
                                        trunk.originationUrls.length > 0
                                    "
                                    class="caption"
                                  >
                                    Inbound:
                                    {{ trunk.originationUrls.length }} route(s)
                                    configured
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle
                                    v-if="
                                      trunk.terminationUrls &&
                                        trunk.terminationUrls.length > 0
                                    "
                                    class="caption"
                                  >
                                    Outbound:
                                    {{ trunk.terminationUrls.length }}
                                    termination(s)
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-btn
                                    x-small
                                    outlined
                                    color="primary"
                                    :href="
                                      'https://console.twilio.com/us1/develop/sip-trunking/trunks/' +
                                        trunk.sid
                                    "
                                    target="_blank"
                                  >
                                    <v-icon x-small>mdi-open-in-new</v-icon>
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list>
                          </div>

                          <!-- Show carrier config status -->
                          <div
                            v-if="
                              twilioCarrier &&
                                twilioCarrier.type === 'twilio-elastic-trunk'
                            "
                            class="mt-3"
                          >
                            <v-divider class="mb-3"></v-divider>
                            <v-alert type="success" dense text>
                              <strong>Ready for SIP Calling!</strong>
                              <p class="mb-0 caption">
                                Your Elastic SIP Trunk is configured for GoDial.
                              </p>
                            </v-alert>
                          </div>

                          <!-- Setup Steps Needed - Only show if user has both phone and trunk (rare edge cases) -->
                          <div
                            v-if="
                              twilioNeedsSetup &&
                                twilioNeedsSetup.length > 0 &&
                                twilioPhoneNumbers &&
                                twilioPhoneNumbers.length > 0 &&
                                twilioElasticTrunks &&
                                twilioElasticTrunks.length > 0
                            "
                            class="mt-4"
                          >
                            <v-divider class="mb-3"></v-divider>
                            <v-alert
                              type="warning"
                              dense
                              text
                              class="text-left mb-3"
                            >
                              <strong>Additional Setup Required</strong>
                              <p class="mb-0 caption">
                                Complete the following steps in your Twilio
                                account:
                              </p>
                            </v-alert>

                            <v-list dense class="text-left">
                              <v-list-item
                                v-for="(step, idx) in twilioNeedsSetup"
                                :key="idx"
                                class="px-0"
                              >
                                <v-list-item-icon class="mr-2">
                                  <v-icon color="warning" small
                                    >mdi-alert-circle</v-icon
                                  >
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title class="subtitle-2">{{
                                    step.title
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle class="caption">{{
                                    step.description
                                  }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action v-if="step.twilioUrl">
                                  <v-btn
                                    x-small
                                    outlined
                                    color="primary"
                                    :href="step.twilioUrl"
                                    target="_blank"
                                  >
                                    <v-icon x-small left
                                      >mdi-open-in-new</v-icon
                                    >
                                    Setup
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list>
                          </div>
                        </v-card>

                        <!-- Not Connected State - Twilio Connect -->
                        <v-card
                          v-else-if="!twilioOAuthAccountSid"
                          elevation="3"
                          class="pa-6 twilio-form-card"
                        >
                          <div class="text-center">
                            <img
                              src="https://upload.wikimedia.org/wikipedia/commons/7/7e/Twilio-logo-red.svg"
                              height="50"
                              alt="Twilio"
                              class="mb-4"
                            />
                            <h3 class="modern-h3 mb-2">
                              Connect Your Twilio Account
                            </h3>
                            <p class="modern-p mb-5">
                              Click the button below to securely connect your
                              Twilio account
                            </p>

                            <!-- Main One-Click Connect Button -->
                            <v-btn
                              color="#F22F46"
                              x-large
                              depressed
                              dark
                              class="mb-4 text-capitalize twilio-connect-btn"
                              :loading="twilioConnecting"
                              @click="connectWithTwilioOAuth"
                            >
                              <img
                                src="https://upload.wikimedia.org/wikipedia/commons/7/7e/Twilio-logo-red.svg"
                                height="24"
                                alt="Twilio"
                                class="mr-3"
                                style="filter: brightness(0) invert(1);"
                              />
                              Connect with Twilio
                            </v-btn>

                            <p class="caption grey--text mb-4">
                              You'll be redirected to Twilio to authorize GoDial
                            </p>

                            <v-alert
                              v-if="twilioError"
                              type="error"
                              dense
                              text
                              class="mt-3 text-left"
                            >
                              {{ twilioError }}
                            </v-alert>

                            <!-- Show fetched phone numbers -->
                            <div
                              v-if="
                                twilioPhoneNumbers &&
                                  twilioPhoneNumbers.length > 0
                              "
                              class="mt-4"
                            >
                              <v-divider class="mb-4"></v-divider>
                              <p class="caption font-weight-bold mb-2">
                                Available Phone Numbers:
                              </p>
                              <v-chip-group column class="justify-center">
                                <v-chip
                                  v-for="num in twilioPhoneNumbers"
                                  :key="num.sid || num.phoneNumber"
                                  small
                                  outlined
                                  color="primary"
                                >
                                  <v-icon small left>mdi-phone</v-icon>
                                  {{ num.phoneNumber }}
                                </v-chip>
                              </v-chip-group>
                            </div>

                            <v-divider class="my-5"></v-divider>

                            <!-- Manual Connect Expansion -->
                            <v-expansion-panels flat>
                              <v-expansion-panel>
                                <v-expansion-panel-header
                                  class="caption grey--text"
                                >
                                  <v-icon small class="mr-2"
                                    >mdi-cog-outline</v-icon
                                  >
                                  Advanced: Connect with Account SID & Auth
                                  Token
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                  <v-form
                                    ref="twilioManualForm"
                                    v-model="twilioManualFormValid"
                                    class="text-left mt-3"
                                  >
                                    <v-text-field
                                      v-model="
                                        twilioManualCredentials.accountSid
                                      "
                                      label="Account SID"
                                      placeholder="ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                                      outlined
                                      dense
                                      class="mb-2"
                                      prepend-inner-icon="mdi-identifier"
                                      :rules="[
                                        (v) => !!v || 'Account SID is required',
                                        (v) =>
                                          /^AC[a-f0-9]{32}$/i.test(v) ||
                                          'Invalid Account SID format',
                                      ]"
                                    ></v-text-field>

                                    <v-text-field
                                      v-model="
                                        twilioManualCredentials.authToken
                                      "
                                      label="Auth Token"
                                      placeholder="Your Twilio Auth Token"
                                      outlined
                                      dense
                                      class="mb-3"
                                      prepend-inner-icon="mdi-key"
                                      :type="
                                        showTwilioAuthToken
                                          ? 'text'
                                          : 'password'
                                      "
                                      :append-icon="
                                        showTwilioAuthToken
                                          ? 'mdi-eye-off'
                                          : 'mdi-eye'
                                      "
                                      :rules="[
                                        (v) => !!v || 'Auth Token is required',
                                      ]"
                                      @click:append="
                                        showTwilioAuthToken = !showTwilioAuthToken
                                      "
                                    ></v-text-field>

                                    <v-btn
                                      color="#F22F46"
                                      depressed
                                      dark
                                      block
                                      class="text-capitalize"
                                      :loading="twilioConnecting"
                                      :disabled="!twilioManualFormValid"
                                      @click="connectWithTwilioManual"
                                    >
                                      <v-icon left small
                                        >mdi-link-variant</v-icon
                                      >
                                      Connect with Credentials
                                    </v-btn>

                                    <p
                                      class="caption grey--text mt-3 text-center"
                                    >
                                      <v-icon x-small class="mr-1"
                                        >mdi-help-circle-outline</v-icon
                                      >
                                      Find your credentials in the
                                      <a
                                        href="https://console.twilio.com/"
                                        target="_blank"
                                        class="twilio-link"
                                        >Twilio Console</a
                                      >
                                    </p>
                                  </v-form>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>

                            <v-divider class="my-4"></v-divider>

                            <p class="caption grey--text mb-2">
                              Don't have a Twilio account?
                            </p>
                            <v-btn
                              text
                              color="#F22F46"
                              small
                              class="text-capitalize"
                              @click="openTwilioSignup"
                            >
                              <v-icon small left>mdi-open-in-new</v-icon>
                              Create Free Twilio Account
                            </v-btn>
                          </div>
                        </v-card>

                        <!-- OAuth AccountSid Captured - Completing Connection -->
                        <v-card
                          v-else
                          elevation="3"
                          class="pa-6 twilio-form-card"
                        >
                          <div class="text-center">
                            <v-avatar color="primary" size="80" class="mb-4">
                              <v-icon
                                v-if="!twilioConnecting"
                                size="40"
                                color="white"
                                >mdi-account-check</v-icon
                              >
                              <v-progress-circular
                                v-else
                                indeterminate
                                color="white"
                                size="40"
                              ></v-progress-circular>
                            </v-avatar>
                            <h3 class="modern-h3 mb-2">
                              {{
                                twilioConnecting
                                  ? "Connecting..."
                                  : "Account Verified!"
                              }}
                            </h3>
                            <p class="modern-p mb-2">
                              {{
                                twilioConnecting
                                  ? "Setting up your Twilio integration..."
                                  : "Your Twilio account has been authorized."
                              }}
                            </p>
                            <v-chip color="primary" outlined class="mb-4">
                              <v-icon small left>mdi-identifier</v-icon>
                              {{
                                twilioOAuthAccountSid
                                  ? twilioOAuthAccountSid.substring(0, 10) +
                                    "..."
                                  : ""
                              }}
                            </v-chip>

                            <v-progress-linear
                              v-if="twilioConnecting"
                              indeterminate
                              color="primary"
                              class="mb-4"
                            ></v-progress-linear>

                            <v-alert
                              v-if="twilioError"
                              type="error"
                              dense
                              text
                              class="mt-3 text-left"
                            >
                              {{ twilioError }}
                              <div class="mt-2">
                                <v-btn
                                  color="error"
                                  small
                                  depressed
                                  @click="completeTwilioOAuthConnection"
                                >
                                  <v-icon small left>mdi-refresh</v-icon>
                                  Try Again
                                </v-btn>
                              </div>
                            </v-alert>

                            <v-btn
                              v-if="!twilioConnecting"
                              text
                              small
                              color="grey"
                              class="text-capitalize mt-2"
                              block
                              @click="twilioOAuthAccountSid = null"
                            >
                              <v-icon small left>mdi-arrow-left</v-icon>
                              Start Over
                            </v-btn>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Own SIP Provider Setup -->
                  <div v-else-if="cloudProviderType === 'own'">
                    <div class="text-center mb-6">
                      <div class="step-badge mb-4">
                        <v-chip
                          color="primary"
                          small
                          outlined
                          class="font-weight-bold"
                        >
                          <v-icon x-small left>mdi-server-network</v-icon>
                          STEP 4
                        </v-chip>
                      </div>
                      <h1 class="modern-h1 mb-3">
                        Configure Your SIP Provider
                      </h1>
                      <p class="modern-p">
                        Enter your SIP trunk credentials to set up cloud calling
                      </p>
                    </div>

                    <v-row justify="center">
                      <v-col cols="12" md="10">
                        <v-card elevation="3" class="pa-6">
                          <!-- Connection Settings -->
                          <div class="section-header mb-4">
                            <v-icon color="primary" class="mr-2"
                              >mdi-connection</v-icon
                            >
                            <span class="section-title"
                              >Connection Details</span
                            >
                          </div>

                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="carrierSettings.name"
                                label="Carrier Name"
                                placeholder="My SIP Provider"
                                outlined
                                dense
                                hide-details="auto"
                                class="mb-3"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon color="primary" size="20"
                                    >mdi-tag</v-icon
                                  >
                                </template>
                              </v-text-field>
                            </v-col>

                            <v-col cols="12" md="8">
                              <v-text-field
                                v-model="carrierSettings.host"
                                label="SIP Host *"
                                placeholder="sip.yourprovider.com"
                                outlined
                                dense
                                hide-details="auto"
                                class="mb-3"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon color="primary" size="20"
                                    >mdi-server</v-icon
                                  >
                                </template>
                              </v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                              <v-text-field
                                v-model="carrierSettings.port"
                                label="Port *"
                                placeholder="5060"
                                outlined
                                dense
                                type="number"
                                hide-details="auto"
                                class="mb-3"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon color="primary" size="20"
                                    >mdi-numeric</v-icon
                                  >
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>

                          <!-- Authentication -->
                          <div class="section-header mb-4 mt-4">
                            <v-icon color="primary" class="mr-2"
                              >mdi-shield-key</v-icon
                            >
                            <span class="section-title">Authentication</span>
                          </div>

                          <v-row>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="carrierSettings.username"
                                label="Username *"
                                placeholder="Enter username"
                                outlined
                                dense
                                hide-details="auto"
                                autocomplete="off"
                                class="mb-3"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon color="primary" size="20"
                                    >mdi-account</v-icon
                                  >
                                </template>
                              </v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="carrierSettings.password"
                                label="Password *"
                                placeholder="Enter password"
                                outlined
                                dense
                                type="password"
                                hide-details="auto"
                                autocomplete="new-password"
                                class="mb-3"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon color="primary" size="20"
                                    >mdi-lock</v-icon
                                  >
                                </template>
                              </v-text-field>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field
                                v-model="carrierSettings.fromDomain"
                                label="From Domain (Optional)"
                                placeholder="domain.com"
                                outlined
                                dense
                                hide-details="auto"
                                class="mb-3"
                              >
                                <template v-slot:prepend-inner>
                                  <v-icon color="primary" size="20"
                                    >mdi-web</v-icon
                                  >
                                </template>
                              </v-text-field>
                              <p class="caption grey--text">
                                Override the domain in From header (leave empty
                                to use default)
                              </p>
                            </v-col>
                          </v-row>

                          <!-- Action Buttons -->
                          <v-row class="mt-4">
                            <v-col cols="12" sm="6">
                              <v-btn
                                outlined
                                color="primary"
                                block
                                class="text-capitalize"
                                :loading="carrierTesting"
                                @click="testCarrierConnection"
                              >
                                <v-icon left small>mdi-flask-outline</v-icon>
                                Test Connection
                              </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-btn
                                color="primary"
                                depressed
                                block
                                class="text-capitalize"
                                :loading="carrierSaving"
                                :disabled="carrierSaved"
                                @click="saveCarrierSettings"
                              >
                                <v-icon v-if="carrierSaved" left small
                                  >mdi-check-circle</v-icon
                                >
                                <v-icon v-else left small
                                  >mdi-content-save</v-icon
                                >
                                {{
                                  carrierSaved
                                    ? "Settings Saved"
                                    : "Save Settings"
                                }}
                              </v-btn>
                            </v-col>
                          </v-row>

                          <!-- Test Result -->
                          <v-alert
                            v-if="carrierTestResult === 'success'"
                            type="success"
                            dense
                            text
                            class="mt-4"
                          >
                            <v-icon small class="mr-2">mdi-check-circle</v-icon>
                            Connection successful! Your SIP provider is
                            reachable.
                          </v-alert>
                          <v-alert
                            v-else-if="carrierTestResult === 'failed'"
                            type="error"
                            dense
                            text
                            class="mt-4"
                          >
                            <v-icon small class="mr-2">mdi-alert-circle</v-icon>
                            Connection failed. Please verify your settings and
                            try again.
                          </v-alert>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn text class="text-capitalize" @click="e1 = 4">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    class="px-8 text-capitalize"
                    :disabled="
                      (cloudProviderType === 'twilio' && !twilioConnected) ||
                        (cloudProviderType === 'own' && !carrierSaved)
                    "
                    @click="handleStep4Continue"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <!-- For SIM: First Call -->
            <template v-else>
              <v-card flat class="call-card gradient-bg">
                <!-- Decorative Elements -->
                <div class="decorative-circle circle-1"></div>
                <div class="decorative-circle circle-3"></div>

                <v-card-text
                  class="pa-5"
                  style="position: relative; z-index: 1;"
                >
                  <div class="text-center mb-4">
                    <div class="step-badge mb-4">
                      <v-chip
                        color="primary"
                        small
                        outlined
                        class="font-weight-bold"
                      >
                        <v-icon x-small left>mdi-phone-outgoing</v-icon>
                        STEP 4
                      </v-chip>
                    </div>
                  </div>
                  <v-row>
                    <v-col cols="12" md="7">
                      <div class="content-section">
                        <h1 class="modern-h1 mb-4">Let's Make A Call</h1>
                        <p class="modern-p mb-4">
                          Well, now that you are set, why not make the first
                          call? Scan the QR on your phone and begin.
                        </p>

                        <v-list dense class="transparent">
                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">1</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >Install the App and Login</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">2</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >Your contact will appear in the
                                dialer</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">3</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >Click Start to begin calling</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">4</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >After the call, set disposition and send
                                messages</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">5</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >Record every call
                                automatically</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                    </v-col>

                    <v-col cols="12" md="5" class="text-center">
                      <v-card
                        elevation="2"
                        class="qr-card mx-auto pa-4"
                        max-width="280"
                      >
                        <div class="mb-3">
                          <v-icon color="primary" size="40"
                            >mdi-qrcode-scan</v-icon
                          >
                          <h3 class="mt-2">Scan to Download</h3>
                        </div>
                        <img
                          src="../assets/appdownloadqr.png"
                          height="200"
                          class="qr-image"
                        />
                        <v-btn
                          color="primary"
                          block
                          depressed
                          class="mt-4 text-capitalize"
                          @click="openLink"
                        >
                          <v-icon left>mdi-open-in-new</v-icon>
                          Open Link
                        </v-btn>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-divider class="my-6"></v-divider>

                  <div v-if="!contactCalled" class="waiting-section">
                    <v-card color="grey lighten-4" flat class="pa-6">
                      <div class="text-center">
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          size="40"
                          width="3"
                        ></v-progress-circular>
                        <p class="mt-4 mb-0 modern-p">
                          Waiting for you to make the first call...
                        </p>
                      </div>
                    </v-card>
                  </div>

                  <div v-else class="call-complete-section">
                    <v-row align="center">
                      <v-col cols="12" sm="4" class="text-center">
                        <v-avatar color="success" size="80">
                          <v-icon size="40" color="white"
                            >mdi-check-circle</v-icon
                          >
                        </v-avatar>
                        <p class="mt-3 mb-0 success--text font-weight-bold">
                          Call Completed!
                        </p>
                      </v-col>

                      <v-col cols="12" sm="8">
                        <v-card elevation="3">
                          <v-card-text class="pa-4">
                            <div class="call-details">
                              <div class="d-flex align-center mb-2">
                                <v-icon color="primary" class="mr-2"
                                  >mdi-account-circle</v-icon
                                >
                                <span class="modern-p mb-0">{{
                                  contactCalledDetails.name
                                }}</span>
                              </div>
                              <div class="d-flex align-center mb-2">
                                <v-icon color="primary" class="mr-2"
                                  >mdi-phone-outline</v-icon
                                >
                                <span class="modern-p mb-0">{{
                                  contactCalledDetails.phone
                                }}</span>
                              </div>
                              <div class="d-flex align-center">
                                <v-icon color="primary" class="mr-2"
                                  >mdi-tag-outline</v-icon
                                >
                                <v-chip
                                  small
                                  :color="getColor(contactCalledDetails.dispo)"
                                  text-color="white"
                                >
                                  {{ contactCalledDetails.dispo }}
                                </v-chip>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn text class="text-capitalize" @click="e1 = 4">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    class="px-8 text-capitalize"
                    @click="e1 = 6"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-stepper-content>

          <!-- Step 6: SIP Trunk Setup (Cloud/Twilio only) -->
          <v-stepper-content step="6">
            <template
              v-if="
                selectedCallingType === 'cloud' &&
                  cloudProviderType === 'twilio'
              "
            >
              <v-card flat class="setup-card gradient-bg">
                <!-- Decorative Elements -->
                <div class="decorative-circle circle-1"></div>
                <div class="decorative-circle circle-2"></div>

                <v-card-text
                  class="pa-5"
                  style="position: relative; z-index: 1;"
                >
                  <div class="text-center mb-6">
                    <div class="step-badge mb-4">
                      <v-chip
                        color="primary"
                        small
                        outlined
                        class="font-weight-bold"
                      >
                        <v-icon x-small left
                          >mdi-transit-connection-variant</v-icon
                        >
                        STEP 5
                      </v-chip>
                    </div>
                    <h1 class="modern-h1 mb-3">Elastic SIP Trunk</h1>
                    <p class="modern-p">
                      Configure your SIP trunk for making and receiving calls
                    </p>
                  </div>

                  <v-row justify="center">
                    <v-col cols="12" md="10">
                      <!-- Loading State -->
                      <v-card
                        v-if="trunkLoading"
                        elevation="3"
                        class="pa-6 text-center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          size="50"
                          class="mb-4"
                        ></v-progress-circular>
                        <p class="modern-p mb-0">Loading SIP Trunks...</p>
                      </v-card>

                      <!-- Main Content -->
                      <v-card
                        v-else
                        elevation="3"
                        class="pa-0 overflow-hidden trunk-main-card"
                      >
                        <!-- Two Option Tabs -->
                        <v-tabs
                          v-model="trunkMode"
                          centered
                          grow
                          background-color="grey lighten-4"
                          slider-color="primary"
                          class="trunk-tabs"
                          show-arrows
                        >
                          <v-tab
                            href="#existing"
                            class="trunk-tab"
                            :disabled="
                              !twilioElasticTrunks ||
                                twilioElasticTrunks.length === 0
                            "
                          >
                            <v-icon small left>mdi-format-list-bulleted</v-icon>
                            <span class="tab-text">Existing Trunk</span>
                            <v-chip
                              v-if="
                                twilioElasticTrunks &&
                                  twilioElasticTrunks.length > 0
                              "
                              x-small
                              class="ml-2 trunk-count-chip"
                              color="primary"
                              outlined
                            >
                              {{ twilioElasticTrunks.length }}
                            </v-chip>
                          </v-tab>
                          <v-tab href="#create" class="trunk-tab">
                            <v-icon small left>mdi-plus-circle</v-icon>
                            <span class="tab-text">Create New</span>
                          </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="trunkMode">
                          <!-- Existing Trunks Tab -->
                          <v-tab-item value="existing">
                            <div class="pa-5">
                              <!-- No trunks message -->
                              <div
                                v-if="
                                  !twilioElasticTrunks ||
                                    twilioElasticTrunks.length === 0
                                "
                                class="text-center py-6"
                              >
                                <v-avatar
                                  color="grey lighten-2"
                                  size="60"
                                  class="mb-3"
                                >
                                  <v-icon size="30" color="grey"
                                    >mdi-transit-connection-variant</v-icon
                                  >
                                </v-avatar>
                                <h3 class="modern-h3 mb-2 grey--text">
                                  No Existing Trunks
                                </h3>
                                <p class="modern-p grey--text mb-4">
                                  You don't have any SIP trunks yet. Create a
                                  new one to get started.
                                </p>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="trunkMode = 'create'"
                                >
                                  <v-icon left>mdi-plus</v-icon>
                                  Create New Trunk
                                </v-btn>
                              </div>

                              <!-- Trunk list -->
                              <div v-else>
                                <div class="d-flex align-center mb-4">
                                  <p class="modern-p mb-0 grey--text">
                                    Select a trunk to use with GoDial
                                  </p>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    x-small
                                    color="primary"
                                    :loading="trunkRefreshing"
                                    @click="refreshElasticTrunks"
                                  >
                                    <v-icon x-small left>mdi-refresh</v-icon>
                                    Refresh
                                  </v-btn>
                                </div>

                                <v-radio-group
                                  v-model="selectedTrunkSid"
                                  class="mt-0"
                                  hide-details
                                >
                                  <v-card
                                    v-for="trunk in twilioElasticTrunks"
                                    :key="trunk.sid"
                                    :outlined="selectedTrunkSid !== trunk.sid"
                                    :color="
                                      selectedTrunkSid === trunk.sid
                                        ? 'primary lighten-5'
                                        : ''
                                    "
                                    :class="[
                                      'mb-3 trunk-selection-card',
                                      {
                                        'selected-trunk-card':
                                          selectedTrunkSid === trunk.sid,
                                      },
                                    ]"
                                    style="cursor: pointer;"
                                    @click="selectedTrunkSid = trunk.sid"
                                  >
                                    <v-card-text class="pa-4">
                                      <div class="d-flex align-center">
                                        <v-radio
                                          :value="trunk.sid"
                                          class="mr-3 mt-0"
                                          @click.stop
                                        ></v-radio>
                                        <div class="flex-grow-1">
                                          <div class="d-flex align-center mb-1">
                                            <v-icon
                                              color="primary"
                                              small
                                              class="mr-2"
                                              >mdi-transit-connection-variant</v-icon
                                            >
                                            <span
                                              class="subtitle-1 font-weight-bold"
                                              >{{ trunk.friendlyName }}</span
                                            >
                                          </div>
                                          <p class="caption grey--text mb-0">
                                            <v-icon x-small class="mr-1"
                                              >mdi-identifier</v-icon
                                            >
                                            {{ trunk.sid }}
                                          </p>
                                        </div>
                                        <v-btn
                                          icon
                                          x-small
                                          color="primary"
                                          :href="
                                            'https://www.twilio.com/console/sip-trunking/trunks/' +
                                              trunk.sid
                                          "
                                          target="_blank"
                                          @click.stop
                                        >
                                          <v-icon small>mdi-open-in-new</v-icon>
                                        </v-btn>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-radio-group>
                              </div>
                            </div>
                          </v-tab-item>

                          <!-- Create New Trunk Tab -->
                          <v-tab-item value="create">
                            <div class="pa-5">
                              <div class="text-center mb-5">
                                <v-avatar
                                  color="primary lighten-4"
                                  size="60"
                                  class="mb-3"
                                >
                                  <v-icon size="30" color="primary"
                                    >mdi-plus-circle</v-icon
                                  >
                                </v-avatar>
                                <h3 class="modern-h3 mb-2">
                                  Create New SIP Trunk
                                </h3>
                                <p class="modern-p grey--text">
                                  Set up a new Elastic SIP Trunk on your Twilio
                                  account
                                </p>
                              </div>

                              <v-alert type="info" dense text class="mb-4">
                                <strong>What is an Elastic SIP Trunk?</strong>
                                <p class="mb-0 caption">
                                  Elastic SIP Trunks allow you to make and
                                  receive calls through Twilio's global network
                                  using the SIP protocol.
                                </p>
                              </v-alert>

                              <v-form
                                ref="createTrunkFormNew"
                                class="text-left"
                              >
                                <v-text-field
                                  v-model="newTrunkName"
                                  label="Trunk Name *"
                                  placeholder="e.g., GoDial Business Trunk"
                                  outlined
                                  dense
                                  prepend-inner-icon="mdi-label"
                                  class="mb-3"
                                  :rules="[
                                    (v) => !!v || 'Trunk name is required',
                                  ]"
                                ></v-text-field>

                                <v-btn
                                  color="primary"
                                  block
                                  large
                                  depressed
                                  :loading="trunkCreating"
                                  :disabled="!newTrunkName"
                                  @click="createNewElasticTrunk"
                                >
                                  <v-icon left>mdi-plus</v-icon>
                                  Create Elastic SIP Trunk
                                </v-btn>
                              </v-form>

                              <div
                                v-if="
                                  twilioElasticTrunks &&
                                    twilioElasticTrunks.length > 0
                                "
                                class="text-center mt-4 pt-4"
                                style="border-top: 1px dashed #e0e0e0;"
                              >
                                <p class="caption grey--text mb-2">
                                  <v-icon x-small class="mr-1"
                                    >mdi-information-outline</v-icon
                                  >
                                  You have
                                  {{ twilioElasticTrunks.length }} existing
                                  trunk(s)
                                </p>
                                <v-btn
                                  text
                                  small
                                  color="primary"
                                  @click="trunkMode = 'existing'"
                                >
                                  Use Existing Trunk Instead
                                </v-btn>
                              </div>
                            </div>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-card>

                      <!-- Error Alert -->
                      <v-alert
                        v-if="trunkError"
                        type="error"
                        dense
                        text
                        class="mt-4"
                        dismissible
                        @input="trunkError = null"
                      >
                        {{ trunkError }}
                      </v-alert>

                      <!-- Success Alert -->
                      <v-alert
                        v-if="trunkSuccess"
                        type="success"
                        dense
                        text
                        class="mt-4"
                        dismissible
                        @input="trunkSuccess = null"
                      >
                        {{ trunkSuccess }}
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn
                    text
                    class="text-capitalize"
                    :disabled="trunkConfiguring"
                    @click="e1 = 5"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    class="px-8 text-capitalize"
                    :disabled="!selectedTrunkSid && trunkMode === 'existing'"
                    :loading="trunkConfiguring"
                    @click="useSelectedTrunk"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>

            <!-- For SIM: Finish -->
            <template v-else>
              <v-card flat class="finish-card gradient-bg celebration-card">
                <!-- Decorative Elements -->
                <div class="decorative-circle circle-1"></div>
                <div class="decorative-circle circle-2"></div>
                <div class="decorative-circle circle-3"></div>

                <!-- Confetti Effect -->
                <div class="confetti-container">
                  <div class="confetti"></div>
                  <div class="confetti"></div>
                  <div class="confetti"></div>
                  <div class="confetti"></div>
                  <div class="confetti"></div>
                </div>

                <v-card-text
                  class="pa-5"
                  style="position: relative; z-index: 1;"
                >
                  <v-row align="center">
                    <v-col cols="12" md="4" class="text-center">
                      <div class="trophy-wrapper">
                        <v-avatar
                          color="success"
                          size="120"
                          class="mb-4 trophy-avatar"
                        >
                          <v-icon size="60" color="white"
                            >mdi-trophy-variant</v-icon
                          >
                        </v-avatar>
                      </div>
                      <h2 class="modern-h2 mb-2">Great Work!</h2>
                      <v-chip
                        color="success"
                        text-color="white"
                        small
                        class="celebration-chip"
                      >
                        <v-icon x-small left>mdi-check-all</v-icon>
                        Setup Complete
                      </v-chip>
                    </v-col>

                    <v-col cols="12" md="8">
                      <div class="content-section">
                        <p class="modern-p mb-4">
                          You are a pro now! You have successfully added data
                          and even made the first call. Now all you have to do
                          is check the reports.
                        </p>
                        <p class="modern-p mb-4">
                          Make sure to Connect your
                          <strong>WhatsApp Business</strong> and Broadcast
                          messages and reply from the team inbox, directly from
                          GoDial. Do check out all the tabs, and feel free to
                          contact my team and me for every need of yours.
                        </p>
                        <p class="modern-p mb-6">
                          <strong
                            >Take care, and have a great time GoDialling!
                            🚀</strong
                          >
                        </p>

                        <h3 class="modern-h3 mb-3">Quick Actions</h3>
                        <v-list dense class="transparent next-steps-list">
                          <v-list-item
                            class="modern-list-item"
                            @click="
                              fts();
                              $router.replace({
                                path: '/users',
                                query: { tp: true },
                              });
                            "
                          >
                            <v-list-item-avatar color="primary" size="36">
                              <v-icon color="white" size="20"
                                >mdi-account-multiple</v-icon
                              >
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-title"
                                >Add your team</v-list-item-title
                              >
                              <v-list-item-subtitle
                                >Invite team members to
                                collaborate</v-list-item-subtitle
                              >
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-action>
                          </v-list-item>

                          <v-list-item
                            class="modern-list-item"
                            @click="
                              fts();
                              $router.replace({
                                path: '/lists',
                                query: { cp: true },
                              });
                            "
                          >
                            <v-list-item-avatar color="primary" size="36">
                              <v-icon color="white" size="20"
                                >mdi-upload</v-icon
                              >
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-title"
                                >Import your contacts</v-list-item-title
                              >
                              <v-list-item-subtitle
                                >Upload contacts from Excel or
                                CSV</v-list-item-subtitle
                              >
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-action>
                          </v-list-item>

                          <v-list-item
                            class="modern-list-item"
                            @click="
                              fts();
                              $router.replace('/whatsapp-settings');
                            "
                          >
                            <v-list-item-avatar color="success" size="36">
                              <v-icon color="white" size="20"
                                >mdi-whatsapp</v-icon
                              >
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-title"
                                >Connect WhatsApp Business</v-list-item-title
                              >
                              <v-list-item-subtitle
                                >Send messages and manage
                                conversations</v-list-item-subtitle
                              >
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-action>
                          </v-list-item>

                          <v-list-item
                            class="modern-list-item"
                            @click="
                              fts();
                              $router.replace('/reports');
                            "
                          >
                            <v-list-item-avatar color="orange" size="36">
                              <v-icon color="white" size="20"
                                >mdi-chart-bar</v-icon
                              >
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-title"
                                >Checkout your reports</v-list-item-title
                              >
                              <v-list-item-subtitle
                                >View analytics and
                                performance</v-list-item-subtitle
                              >
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn text class="text-capitalize" @click="e1 = 5">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="success"
                    large
                    depressed
                    class="px-8 text-capitalize"
                    @click="fts"
                  >
                    <v-icon left>mdi-check-circle</v-icon>
                    Finish Setup
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-stepper-content>

          <!-- Step 7: Phone Numbers & DID Configuration (Twilio only) -->
          <v-stepper-content step="7">
            <template
              v-if="
                selectedCallingType === 'cloud' &&
                  cloudProviderType === 'twilio'
              "
            >
              <v-card flat class="trunk-card gradient-bg">
                <div class="decorative-circle circle-1"></div>
                <div class="decorative-circle circle-2"></div>

                <v-card-text
                  class="pa-5"
                  style="position: relative; z-index: 1;"
                >
                  <div class="text-center mb-4">
                    <div class="step-badge mb-4">
                      <v-chip
                        color="primary"
                        small
                        outlined
                        class="font-weight-bold"
                      >
                        <v-icon x-small left>mdi-phone-settings</v-icon>
                        STEP 6
                      </v-chip>
                    </div>
                    <h1 class="modern-h1 mb-2">Phone Numbers & Routing</h1>
                    <p class="modern-p grey--text">
                      Configure your phone numbers and inbound call routing
                    </p>
                  </div>

                  <v-row justify="center">
                    <v-col cols="12" md="10">
                      <!-- Loading State -->
                      <v-card
                        v-if="phoneNumbersLoading"
                        elevation="3"
                        class="pa-6 text-center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          size="50"
                          class="mb-4"
                        ></v-progress-circular>
                        <h3 class="modern-h3">Loading Phone Numbers...</h3>
                        <p class="modern-p grey--text">
                          Fetching your Twilio phone numbers
                        </p>
                      </v-card>

                      <!-- Phone Numbers Configuration -->
                      <v-card v-else elevation="3" class="pa-6">
                        <div
                          class="d-flex align-center justify-space-between mb-4"
                        >
                          <div>
                            <h3 class="modern-h3 mb-1">Phone Numbers</h3>
                            <p class="caption grey--text mb-0">
                              Select numbers to use with GoDial PBX
                            </p>
                          </div>
                          <div class="d-flex align-center">
                            <v-btn
                              small
                              outlined
                              color="primary"
                              class="mr-2"
                              :loading="phoneNumbersRefreshing"
                              @click="refreshPhoneNumbers"
                            >
                              <v-icon small left>mdi-refresh</v-icon>
                              Refresh
                            </v-btn>
                            <v-btn
                              small
                              color="primary"
                              href="https://console.twilio.com/us1/develop/phone-numbers/manage/search"
                              target="_blank"
                            >
                              <v-icon small left>mdi-plus</v-icon>
                              Buy Number
                            </v-btn>
                          </div>
                        </div>

                        <v-divider class="mb-4"></v-divider>

                        <!-- Phone Numbers List -->
                        <div
                          v-if="
                            twilioPhoneNumbers && twilioPhoneNumbers.length > 0
                          "
                        >
                          <!-- Show phone numbers based on trunk status -->
                          <div v-if="availablePhoneNumbers.length > 0">
                            <!-- Info about selection mode -->
                            <v-alert
                              v-if="!trunkHasConnectedNumbers"
                              type="info"
                              dense
                              text
                              class="mb-3"
                            >
                              <strong>Select One Number</strong>
                              <p class="mb-0 caption mt-1">
                                Choose a phone number to connect to this trunk. The number will be automatically assigned when you continue.
                              </p>
                            </v-alert>

                            <!-- Radio group for single selection when trunk has no numbers -->
                            <v-radio-group
                              v-if="!trunkHasConnectedNumbers"
                              v-model="selectedPhoneNumbers[0]"
                              hide-details
                              class="mt-0"
                              @change="(val) => selectedPhoneNumbers = val ? [val] : []"
                            >
                              <v-card
                                v-for="number in availablePhoneNumbers"
                                :key="number.sid"
                                outlined
                                class="mb-3 phone-number-card"
                                :class="{
                                  'selected-number': selectedPhoneNumbers.includes(
                                    number.phoneNumber,
                                  ),
                                }"
                              >
                                <v-card-text class="pa-4">
                                  <div class="d-flex align-start">
                                    <v-radio
                                      :value="number.phoneNumber"
                                      hide-details
                                      class="mr-3 mt-0 pt-0 flex-shrink-0"
                                    >
                                    </v-radio>
                                    <div class="flex-grow-1 min-width-0">
                                      <div class="d-flex align-center flex-wrap">
                                        <v-icon color="primary" small class="mr-2"
                                          >mdi-phone</v-icon
                                        >
                                        <span
                                          class="subtitle-1 font-weight-bold phone-number-text"
                                          >{{ number.phoneNumber }}</span
                                        >
                                      </div>
                                      <div class="mt-1">
                                        <v-chip
                                          x-small
                                          color="info"
                                          outlined
                                          class="phone-status-chip"
                                        >
                                          <v-icon x-small left>mdi-link-off</v-icon>
                                          Available
                                        </v-chip>
                                      </div>
                                      <p class="caption grey--text mb-0 mt-1">
                                        {{
                                          number.friendlyName ||
                                            number.phoneNumber
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </v-radio-group>

                            <!-- Show connected numbers when trunk already has numbers -->
                            <div v-else>
                              <v-card
                                v-for="number in availablePhoneNumbers"
                                :key="number.sid"
                                outlined
                                class="mb-3 phone-number-card selected-number"
                              >
                                <v-card-text class="pa-4">
                                  <div class="d-flex align-start">
                                    <v-checkbox
                                      v-model="selectedPhoneNumbers"
                                      :value="number.phoneNumber"
                                      disabled
                                      hide-details
                                      class="mr-3 mt-0 pt-0 flex-shrink-0"
                                    >
                                    </v-checkbox>
                                    <div class="flex-grow-1 min-width-0">
                                      <div class="d-flex align-center flex-wrap">
                                        <v-icon color="primary" small class="mr-2"
                                          >mdi-phone</v-icon
                                        >
                                        <span
                                          class="subtitle-1 font-weight-bold phone-number-text"
                                          >{{ number.phoneNumber }}</span
                                        >
                                      </div>
                                      <div class="mt-1">
                                        <v-chip
                                          x-small
                                          color="success"
                                          class="phone-status-chip"
                                        >
                                          <v-icon x-small left>mdi-check</v-icon>
                                          Connected
                                        </v-chip>
                                      </div>
                                      <p class="caption grey--text mb-0 mt-1">
                                        {{
                                          number.friendlyName ||
                                            number.phoneNumber
                                        }}
                                      </p>
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>
                            </div>
                          </div>

                          <!-- Message when no valid numbers available -->
                          <v-alert
                            v-else
                            type="warning"
                            dense
                            text
                            class="mb-3"
                          >
                            <strong>No Available Numbers</strong>
                            <p class="mb-0 caption">
                              All your phone numbers are connected to other
                              trunks. You need to either disconnect them or
                              purchase a new number to proceed.
                            </p>
                          </v-alert>
                        </div>

                        <v-alert v-else type="warning" dense text>
                          <div
                            class="d-flex align-center justify-space-between"
                          >
                            <div>
                              <strong
                                >No phone numbers found in your Twilio
                                account.</strong
                              >
                              <p class="mb-0 caption mt-1">
                                Please purchase a phone number to continue with
                                cloud calling setup.
                              </p>
                            </div>
                            <v-btn
                              small
                              color="primary"
                              href="https://console.twilio.com/us1/develop/phone-numbers/manage/search"
                              target="_blank"
                              class="ml-3"
                            >
                              <v-icon small left>mdi-cart-plus</v-icon>
                              Buy Number
                            </v-btn>
                          </div>
                        </v-alert>

                        <v-divider class="my-4"></v-divider>

                        <!-- DID Routing Configuration -->
                        <div class="mb-4">
                          <h3 class="modern-h3 mb-2">
                            <v-icon color="primary" class="mr-2"
                              >mdi-call-split</v-icon
                            >
                            Inbound Call Routing
                          </h3>
                          <p class="caption grey--text mb-3">
                            Configure how incoming calls are routed to agents
                          </p>

                          <v-select
                            v-model="defaultRoutingType"
                            :items="routingTypes"
                            item-text="text"
                            item-value="value"
                            label="Default Routing Strategy"
                            outlined
                            dense
                            prepend-inner-icon="mdi-route"
                            class="mb-3"
                          >
                            <template v-slot:item="{ item }">
                              <v-icon class="mr-3">{{ item.icon }}</v-icon>
                              <div>
                                <div class="subtitle-2">{{ item.text }}</div>
                                <div class="caption grey--text">
                                  {{ item.description }}
                                </div>
                              </div>
                            </template>
                          </v-select>

                          <v-alert
                            v-if="defaultRoutingType === 'agent'"
                            type="info"
                            dense
                            text
                            class="mb-3"
                          >
                            <strong>Single Agent:</strong> Calls will be routed
                            to a specific agent. You can configure this
                            per-number later.
                          </v-alert>
                          <v-alert
                            v-else-if="defaultRoutingType === 'random-agent'"
                            type="info"
                            dense
                            text
                            class="mb-3"
                          >
                            <strong>Random Agent:</strong> Calls will be
                            randomly distributed among available agents.
                          </v-alert>
                        </div>

                        <!-- Error Alert -->
                        <v-alert
                          v-if="phoneNumbersError"
                          type="error"
                          dense
                          text
                          class="mt-4"
                        >
                          {{ phoneNumbersError }}
                        </v-alert>

                        <!-- Success Alert -->
                        <v-alert
                          v-if="phoneNumbersSuccess"
                          type="success"
                          dense
                          text
                          class="mt-4"
                        >
                          {{ phoneNumbersSuccess }}
                        </v-alert>

                        <!-- Warning when no numbers selected -->
                        <v-alert
                          v-if="
                            availablePhoneNumbers.length > 0 &&
                              selectedPhoneNumbers.length === 0
                          "
                          type="warning"
                          dense
                          text
                          class="mt-4"
                        >
                          <v-icon small class="mr-2">mdi-alert</v-icon>
                          Please select at least one phone number to continue.
                          You can assign unconnected numbers to your trunk
                          first.
                        </v-alert>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn
                    text
                    class="text-capitalize"
                    :disabled="phoneNumbersSaving"
                    @click="e1 = 6"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    class="px-8 text-capitalize"
                    :loading="phoneNumbersSaving"
                    :disabled="!canProceedWithPhoneNumbers"
                    @click="savePhoneNumbersConfig"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-stepper-content>

          <!-- Step 8: Add Contact (Cloud) / Finish (SIM) -->
          <v-stepper-content step="8">
            <!-- For Cloud: Add Contact -->
            <template v-if="selectedCallingType === 'cloud'">
              <v-card flat class="contact-card gradient-bg">
                <!-- Decorative Elements -->
                <div class="decorative-circle circle-1"></div>
                <div class="decorative-circle circle-2"></div>

                <v-card-text
                  class="pa-5"
                  style="position: relative; z-index: 1;"
                >
                  <div class="text-center mb-4">
                    <div class="step-badge mb-4">
                      <v-chip
                        color="primary"
                        small
                        outlined
                        class="font-weight-bold"
                      >
                        <v-icon x-small left>mdi-account-plus</v-icon>
                        STEP 7
                      </v-chip>
                    </div>
                  </div>
                  <v-row>
                    <v-col cols="12" md="7">
                      <div class="content-section">
                        <h1 class="modern-h1 mb-4">Your First Contact</h1>
                        <p class="modern-p mb-4">
                          GoDial's CRM is made up of <strong>Lists</strong> and
                          each list is a set of contacts. Lists are assigned to
                          one or many Members.
                        </p>
                        <p class="modern-p mb-4">
                          For now, let's create a dummy contact for testing. We
                          will add this contact to your
                          <strong>Default list</strong> and assign it to you as
                          well.
                        </p>
                        <v-alert color="#37cf37" text dense class="mt-4">
                          <div class="d-flex align-center">
                            <v-icon color="#37cf37" class="mr-2"
                              >mdi-lightbulb-outline</v-icon
                            >
                            <span class="caption"
                              >You can import bulk contacts later from Excel or
                              CSV files</span
                            >
                          </div>
                        </v-alert>
                      </div>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-card elevation="3" class="modern-form-card">
                        <v-card-text class="pa-6">
                          <div class="text-center mb-4">
                            <v-avatar color="primary" size="60">
                              <v-icon size="30" color="white"
                                >mdi-account-plus</v-icon
                              >
                            </v-avatar>
                            <h3 class="mt-3 mb-2">Add Test Contact</h3>
                          </div>
                          <v-form v-model="valid">
                            <v-text-field
                              v-model="name"
                              :rules="nameRules"
                              label="Name"
                              required
                              placeholder="John Doe"
                              outlined
                              dense
                              hide-details="auto"
                              class="mb-4"
                            >
                              <template v-slot:prepend-inner>
                                <v-icon color="primary" size="20"
                                  >mdi-account</v-icon
                                >
                              </template>
                            </v-text-field>

                            <v-text-field
                              v-model="phone"
                              :rules="phoneRules"
                              label="Phone"
                              required
                              placeholder="+91 7044406666"
                              outlined
                              dense
                              hide-details="auto"
                              class="mb-4"
                            >
                              <template v-slot:prepend-inner>
                                <v-icon color="primary" size="20"
                                  >mdi-phone</v-icon
                                >
                              </template>
                            </v-text-field>

                            <v-btn
                              color="primary"
                              block
                              large
                              depressed
                              :disabled="contactAdded"
                              class="text-capitalize"
                              @click="addContact()"
                            >
                              <v-icon v-if="!contactAdded" left
                                >mdi-plus-circle</v-icon
                              >
                              <v-icon v-else left>mdi-check-circle</v-icon>
                              {{
                                contactAdded ? "Contact Added" : "Add Contact"
                              }}
                            </v-btn>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn
                    text
                    class="text-capitalize"
                    @click="e1 = cloudProviderType === 'twilio' ? 7 : 5"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    class="px-8 text-capitalize"
                    @click="e1 = 9"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-stepper-content>

          <!-- Step 9: First Call (Cloud Only) -->
          <v-stepper-content step="9">
            <template v-if="selectedCallingType === 'cloud'">
              <v-card flat class="call-card gradient-bg">
                <!-- Decorative Elements -->
                <div class="decorative-circle circle-1"></div>
                <div class="decorative-circle circle-3"></div>

                <v-card-text
                  class="pa-5"
                  style="position: relative; z-index: 1;"
                >
                  <div class="text-center mb-4">
                    <div class="step-badge mb-4">
                      <v-chip
                        color="primary"
                        small
                        outlined
                        class="font-weight-bold"
                      >
                        <v-icon x-small left>mdi-phone-outgoing</v-icon>
                        STEP 8
                      </v-chip>
                    </div>
                  </div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="content-section">
                        <h1 class="modern-h1 mb-4">Make Your First Call</h1>
                        <p class="modern-p mb-4">
                          Now that your cloud calling is configured, let's make
                          a test call to verify everything is working correctly.
                        </p>

                        <v-list dense class="transparent">
                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">1</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >Connect to the dialer using the button
                                below</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">2</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >Enter the phone number to
                                call</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">3</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >Click the Call button to place your first
                                call</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-icon class="mr-3">
                              <v-avatar color="primary" size="32">
                                <span class="white--text">4</span>
                              </v-avatar>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title class="modern-list-text"
                                >Complete the call to proceed to
                                finish</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>

                        <v-alert
                          v-if="!cloudFirstCallMade"
                          color="info"
                          text
                          dense
                          class="mt-4"
                        >
                          <div class="d-flex align-center">
                            <v-icon color="info" class="mr-2"
                              >mdi-information-outline</v-icon
                            >
                            <span class="caption"
                              >You can use the contact you just added ({{
                                contactAddedDetails.phone || phone
                              }}) for the test call</span
                            >
                          </div>
                        </v-alert>
                      </div>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-card
                        elevation="3"
                        class="modern-form-card cloud-dialer-card"
                      >
                        <v-card-text class="pa-4">
                          <div class="text-center mb-4">
                            <v-avatar color="primary" size="60">
                              <v-icon size="30" color="white"
                                >mdi-phone-outgoing</v-icon
                              >
                            </v-avatar>
                            <h3 class="mt-3 mb-2">Cloud Dialer</h3>
                          </div>

                          <!-- Dialer Connection Status -->
                          <div class="mb-4">
                            <div
                              class="d-flex align-center justify-space-between mb-2"
                            >
                              <div class="d-flex align-center">
                                <v-icon
                                  :color="
                                    dialerConnectionStatus === 'registered'
                                      ? 'success'
                                      : dialerConnectionStatus === 'connecting'
                                      ? 'warning'
                                      : 'grey'
                                  "
                                  class="mr-2"
                                  small
                                >
                                  {{
                                    dialerConnectionStatus === "registered"
                                      ? "mdi-check-circle"
                                      : dialerConnectionStatus === "connecting"
                                      ? "mdi-loading mdi-spin"
                                      : "mdi-circle-outline"
                                  }}
                                </v-icon>
                                <span class="caption">
                                  {{
                                    dialerConnectionStatus === "registered"
                                      ? "Connected & Ready"
                                      : dialerConnectionStatus === "connecting"
                                      ? "Connecting..."
                                      : "Not Connected"
                                  }}
                                </span>
                              </div>
                              <v-btn
                                v-if="dialerConnectionStatus !== 'registered'"
                                x-small
                                color="primary"
                                outlined
                                :loading="
                                  dialerConnectionStatus === 'connecting'
                                "
                                @click="connectCloudDialer"
                              >
                                <v-icon x-small left>mdi-connection</v-icon>
                                Connect
                              </v-btn>
                              <v-btn
                                v-else
                                x-small
                                color="error"
                                outlined
                                @click="disconnectCloudDialer"
                              >
                                <v-icon x-small left>mdi-phone-hangup</v-icon>
                                Disconnect
                              </v-btn>
                            </div>
                          </div>

                          <!-- Phone Number Input -->
                          <v-text-field
                            v-model="cloudDialerNumber"
                            label="Phone Number"
                            placeholder="Enter number to call"
                            outlined
                            dense
                            :disabled="dialerIsInCall"
                            hide-details="auto"
                            class="mb-3"
                          >
                            <template v-slot:prepend-inner>
                              <v-icon color="primary" size="20"
                                >mdi-phone</v-icon
                              >
                            </template>
                          </v-text-field>

                          <!-- Call Status -->
                          <div
                            v-if="dialerIsInCall || dialerCallStatus !== 'idle'"
                            class="text-center mb-3"
                          >
                            <v-chip
                              :color="
                                dialerCallStatus === 'connected'
                                  ? 'success'
                                  : dialerCallStatus === 'ringing'
                                  ? 'warning'
                                  : 'grey'
                              "
                              text-color="white"
                              small
                            >
                              {{
                                dialerCallStatus === "connected"
                                  ? "In Call"
                                  : dialerCallStatus === "ringing"
                                  ? "Ringing..."
                                  : dialerCallStatus === "calling"
                                  ? "Calling..."
                                  : dialerCallStatus
                              }}
                            </v-chip>
                            <div
                              v-if="dialerIsInCall && dialerCallDuration > 0"
                              class="mt-2 text-h6 font-weight-bold"
                            >
                              {{ formatCallDuration(dialerCallDuration) }}
                            </div>
                          </div>

                          <!-- Call Buttons -->
                          <div class="d-flex">
                            <v-btn
                              v-if="!dialerIsInCall"
                              color="success"
                              block
                              large
                              depressed
                              :disabled="
                                dialerConnectionStatus !== 'registered' ||
                                  !cloudDialerNumber.trim()
                              "
                              class="text-capitalize"
                              @click="makeCloudTestCall"
                            >
                              <v-icon left>mdi-phone</v-icon>
                              Call
                            </v-btn>
                            <v-btn
                              v-else
                              color="error"
                              block
                              large
                              depressed
                              class="text-capitalize"
                              @click="endCloudTestCall"
                            >
                              <v-icon left>mdi-phone-hangup</v-icon>
                              End Call
                            </v-btn>
                          </div>

                          <!-- Call Complete Status -->
                          <div
                            v-if="cloudFirstCallMade"
                            class="text-center mt-4"
                          >
                            <v-avatar color="success" size="48">
                              <v-icon color="white">mdi-check</v-icon>
                            </v-avatar>
                            <p class="mt-2 mb-0 success--text font-weight-bold">
                              Test call completed!
                            </p>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <!-- Hidden Audio Element for Remote Audio -->
                  <audio
                    ref="cloudDialerAudio"
                    autoplay
                    playsinline
                    preload="auto"
                    style="display: none;"
                  ></audio>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                  <v-btn text class="text-capitalize" @click="e1 = 8">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text class="text-capitalize mr-2" @click="e1 = 10">
                    Skip for now
                  </v-btn>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    :disabled="!cloudFirstCallMade"
                    class="px-8 text-capitalize"
                    @click="e1 = 10"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-stepper-content>

          <!-- Step 10: Finish (Cloud Only - Twilio) -->
          <v-stepper-content step="10">
            <v-card flat class="finish-card gradient-bg celebration-card">
              <!-- Decorative Elements -->
              <div class="decorative-circle circle-1"></div>
              <div class="decorative-circle circle-2"></div>
              <div class="decorative-circle circle-3"></div>

              <!-- Confetti Effect -->
              <div class="confetti-container">
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
                <div class="confetti"></div>
              </div>

              <v-card-text class="pa-5" style="position: relative; z-index: 1;">
                <v-row align="center">
                  <v-col cols="12" md="4" class="text-center">
                    <div class="trophy-wrapper">
                      <v-avatar
                        color="success"
                        size="120"
                        class="mb-4 trophy-avatar"
                      >
                        <v-icon size="60" color="white"
                          >mdi-trophy-variant</v-icon
                        >
                      </v-avatar>
                    </div>
                    <h2 class="modern-h2 mb-2">Great Work!</h2>
                    <v-chip
                      color="success"
                      text-color="white"
                      small
                      class="celebration-chip"
                    >
                      <v-icon x-small left>mdi-check-all</v-icon>
                      Setup Complete
                    </v-chip>
                  </v-col>

                  <v-col cols="12" md="8">
                    <div class="content-section">
                      <p class="modern-p mb-4">
                        You are a pro now! You have successfully configured your
                        cloud calling setup. Now all you have to do is check the
                        reports.
                      </p>
                      <p class="modern-p mb-4">
                        Make sure to Connect your
                        <strong>WhatsApp Business</strong> and Broadcast
                        messages and reply from the team inbox, directly from
                        GoDial. Do check out all the tabs, and feel free to
                        contact my team and me for every need of yours.
                      </p>
                      <p class="modern-p mb-6">
                        <strong
                          >Take care, and have a great time GoDialling!
                          🚀</strong
                        >
                      </p>

                      <h3 class="modern-h3 mb-3">Quick Actions</h3>
                      <v-list dense class="transparent next-steps-list">
                        <v-list-item
                          class="modern-list-item"
                          @click="
                            fts();
                            $router.replace('/pbx');
                          "
                        >
                          <v-list-item-avatar color="primary" size="36">
                            <v-icon color="white" size="20"
                              >mdi-phone-settings</v-icon
                            >
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="modern-list-title"
                              >Configure PBX Settings</v-list-item-title
                            >
                            <v-list-item-subtitle
                              >Add DID numbers and more
                              settings</v-list-item-subtitle
                            >
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon>mdi-chevron-right</v-icon>
                          </v-list-item-action>
                        </v-list-item>

                        <v-list-item
                          class="modern-list-item"
                          @click="
                            fts();
                            $router.replace({
                              path: '/users',
                              query: { tp: true },
                            });
                          "
                        >
                          <v-list-item-avatar color="primary" size="36">
                            <v-icon color="white" size="20"
                              >mdi-account-multiple</v-icon
                            >
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="modern-list-title"
                              >Add your team</v-list-item-title
                            >
                            <v-list-item-subtitle
                              >Invite team members to
                              collaborate</v-list-item-subtitle
                            >
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon>mdi-chevron-right</v-icon>
                          </v-list-item-action>
                        </v-list-item>

                        <v-list-item
                          class="modern-list-item"
                          @click="
                            fts();
                            $router.replace('/whatsapp-settings');
                          "
                        >
                          <v-list-item-avatar color="success" size="36">
                            <v-icon color="white" size="20"
                              >mdi-whatsapp</v-icon
                            >
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="modern-list-title"
                              >Connect WhatsApp Business</v-list-item-title
                            >
                            <v-list-item-subtitle
                              >Send messages and manage
                              conversations</v-list-item-subtitle
                            >
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon>mdi-chevron-right</v-icon>
                          </v-list-item-action>
                        </v-list-item>

                        <v-list-item
                          class="modern-list-item"
                          @click="
                            fts();
                            $router.replace('/reports');
                          "
                        >
                          <v-list-item-avatar color="orange" size="36">
                            <v-icon color="white" size="20"
                              >mdi-chart-bar</v-icon
                            >
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title class="modern-list-title"
                              >Checkout your reports</v-list-item-title
                            >
                            <v-list-item-subtitle
                              >View analytics and
                              performance</v-list-item-subtitle
                            >
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon>mdi-chevron-right</v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions class="pa-4">
                <v-btn text class="text-capitalize" @click="e1 = 9">
                  <v-icon left>mdi-arrow-left</v-icon>
                  Back
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  large
                  depressed
                  class="px-8 text-capitalize"
                  @click="fts"
                >
                  <v-icon left>mdi-check-circle</v-icon>
                  Finish Setup
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>

    <v-snackbar v-model="snackbar" multi-line :color="color">
      <h3 style="font-weight: 500; font-size: 13px; text-transform: uppercase">
        {{ snackbarText }}
      </h3>

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment-timezone";
const _ = require("lodash");
import validator from "../js/validator.js";
import fb from "../js/firebase";
import countries from "../js/countries";

export default {
  data() {
    return {
      skipClicked: false,
      showWhatsapp: false,
      snackbar: false,
      snackbarText: "",
      color: "success",
      e1: 1,
      intervalWatch: null,
      dialog: false,
      name: "Godial",
      phone: "+91 7044406666",
      defaultList: "",
      contactAdded: false,
      contactAddedDetails: {},
      contactCalled: false,
      contactCalledDetails: {},
      valid: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 15 || "Name must be less than 15 characters",
      ],
      phoneRules: [
        (v) => !!v || "Phone is required",
        (v) => v.length >= 5 || "Phone must be more than 5 characters",
      ],
      dataAdded: false,
      selectedCallingType: null, // 'sim' or 'cloud'

      // Cloud Dialer First Call Step
      cloudFirstCallMade: false,
      cloudDialerNumber: "",
      cloudDialerConnecting: false,

      // Country selection for recommendation
      callingFromCountry: null,
      callingToCountry: null,
      countryList: countries,

      // Cloud calling sub-options
      cloudProviderType: null, // 'twilio' or 'own'

      // Twilio OAuth state (manual credentials)
      twilioConnecting: false,
      twilioConnected: false,
      twilioAccountInfo: null,
      twilioError: null,
      twilioPhoneNumbers: [],
      twilioSipDomains: [],
      twilioElasticTrunks: [],
      twilioNeedsSetup: [],
      twilioCarrier: null,
      twilioManualFormValid: false,
      showTwilioAuthToken: false,
      // State for OAuth flow - AccountSid captured, waiting for Auth Token
      twilioOAuthAccountSid: null,
      twilioOAuthAuthToken: "",
      twilioManualCredentials: {
        accountSid: "",
        authToken: "",
      },

      // Twilio Quick Setup
      twilioQuickSetup: {
        country: "US",
        numberType: "local",
        areaCode: "",
      },
      twilioQuickSetupLoading: false,
      twilioQuickSetupProgress: [],

      // Twilio Phone Number Search
      twilioSearchParams: {
        country: "US",
        type: "local",
        areaCode: "",
        contains: "",
      },
      twilioSearchLoading: false,
      twilioSearchResults: [],
      twilioPurchasingNumber: null,

      // Twilio Trunk Creation
      twilioTrunkName: "",
      twilioCreatingTrunk: false,

      // SIP Trunk Step (Step 5) data
      trunkMode: "existing", // 'existing' or 'create'
      selectedTrunkSid: null,
      newTrunkName: "",
      trunkLoading: false,
      trunkRefreshing: false,
      trunkCreating: false,
      trunkConfiguring: false,
      trunkError: null,
      trunkSuccess: null,
      // Trunk credentials config (auto-generated for user)
      trunkCredentialUsername: "",
      trunkCredentialPassword: "",
      pbxServerIp: process.env.VUE_APP_PBX_SERVER_IP || "13.234.45.114", // GoDial PBX Server IP (env-based)

      // Step 6: Phone Numbers & DID Configuration
      selectedPhoneNumbers: [],
      trunkPhoneNumbers: [], // Numbers already assigned to the trunk
      phoneNumbersLoading: false,
      phoneNumbersRefreshing: false,
      phoneNumbersSaving: false,
      phoneNumbersError: null,
      phoneNumbersSuccess: null,
      defaultRoutingType: "unassigned",
      routingTypes: [
        {
          text: "Unassigned",
          value: "unassigned",
          icon: "mdi-phone-off",
          description: "Number not routed to any agent",
        },
        {
          text: "Specific Agent",
          value: "agent",
          icon: "mdi-account",
          description: "Route to a specific agent",
        },
        {
          text: "Random Agent",
          value: "random-agent",
          icon: "mdi-shuffle-variant",
          description: "Route randomly to available agents",
        },
      ],

      // Country list for Twilio
      twilioCountries: [
        { name: "United States", code: "US" },
        { name: "United Kingdom", code: "GB" },
        { name: "Canada", code: "CA" },
        { name: "Australia", code: "AU" },
        { name: "Germany", code: "DE" },
        { name: "France", code: "FR" },
        { name: "India", code: "IN" },
        { name: "Brazil", code: "BR" },
        { name: "Mexico", code: "MX" },
        { name: "Spain", code: "ES" },
        { name: "Italy", code: "IT" },
        { name: "Netherlands", code: "NL" },
        { name: "Singapore", code: "SG" },
        { name: "Japan", code: "JP" },
        { name: "South Africa", code: "ZA" },
        { name: "Ireland", code: "IE" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Belgium", code: "BE" },
        { name: "Austria", code: "AT" },
      ],

      // Own SIP Provider settings
      carrierSettings: {
        name: "",
        host: "",
        port: "5060",
        username: "",
        password: "",
        fromDomain: "",
      },
      carrierSaving: false,
      carrierSaved: false,
      carrierTestResult: null,
      carrierTesting: false,
    };
  },
  computed: {
    ...mapGetters(["ENDPOINT", "dispoList", "companyDetails"]),
    ...mapState("dialer", {
      dialerConnectionStatus: "connectionStatus",
      dialerCallStatus: "callStatus",
      dialerIsInCall: "isInCall",
      dialerCallDuration: "callDuration",
    }),
    ...mapGetters("dialer", {
      dialerCanMakeCall: "canMakeCall",
    }),

    // Computed: Check if calling from same country to same country
    isSameCountryCalling() {
      return (
        this.callingFromCountry &&
        this.callingToCountry &&
        this.callingFromCountry === this.callingToCountry
      );
    },

    // Computed: Check if making international calls
    isInternationalCalling() {
      return (
        this.callingFromCountry &&
        this.callingToCountry &&
        this.callingFromCountry !== this.callingToCountry
      );
    },

    // Check if the selected trunk already has connected numbers
    trunkHasConnectedNumbers() {
      if (!this.twilioPhoneNumbers || this.twilioPhoneNumbers.length === 0) {
        return false;
      }
      return this.twilioPhoneNumbers.some(
        (number) => number.trunkSid === this.selectedTrunkSid
      );
    },

    // Filter phone numbers based on trunk connection status
    // If trunk has connected numbers: only show those connected numbers
    // If trunk has no connected numbers: only show unconnected numbers (user can select one)
    availablePhoneNumbers() {
      if (!this.twilioPhoneNumbers || this.twilioPhoneNumbers.length === 0) {
        return [];
      }

      if (this.trunkHasConnectedNumbers) {
        // Trunk already has numbers - only show connected ones
        return this.twilioPhoneNumbers.filter(
          (number) => number.trunkSid === this.selectedTrunkSid
        );
      } else {
        // Trunk has no numbers - show only unconnected numbers
        return this.twilioPhoneNumbers.filter(
          (number) =>
            !number.trunkSid ||
            number.trunkSid === null ||
            number.trunkSid === ""
        );
      }
    },

    // Computed property: Check if user can proceed (has at least one valid number connected)
    canProceedWithPhoneNumbers() {
      // User can proceed only if there are numbers available that are either:
      // 1. Already connected to the selected trunk, OR
      // 2. Available (not connected) and can be assigned
      return (
        this.availablePhoneNumbers.length > 0 &&
        this.selectedPhoneNumbers.length > 0
      );
    },
  },
  watch: {
    // Auto-scroll stepper header to active step on mobile
    e1: {
      handler(newStep) {
        this.$nextTick(() => {
          this.scrollToActiveStep();
        });
      },
      immediate: true,
    },
    // Watch for call end to mark first call as completed
    dialerIsInCall(newVal, oldVal) {
      // If call just ended (was in call, now not in call) and we're on the first call step
      if (oldVal === true && newVal === false && this.e1 === 9) {
        this.cloudFirstCallMade = true;
        this.snackbar = true;
        this.snackbarText = "Test call completed! You can now proceed.";
        this.color = "success";
      }
    },
    // Auto-select calling type based on country selection
    callingFromCountry(newVal) {
      if (newVal && this.callingToCountry) {
        this.autoSelectCallingType();
      }
    },
    callingToCountry(newVal) {
      if (newVal && this.callingFromCountry) {
        this.autoSelectCallingType();
      }
    },
  },
  created() {
    //get the default list
    this.$http
      .get(
        `${this.ENDPOINT}/lists?filter[where][companyId]=${this.$store.state.user.companyId}`,
      )
      .then((response) => {
        this.defaultList = response.body[0].id;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  mounted() {
    const self = this;
    // Check for Twilio Connect redirect parameters in URL
    this.checkTwilioConnectRedirect();
    // Auto-detect country from timezone
    this.detectCountryFromTimezone();
  },
  methods: {
    ...mapActions("dialer", ["connect", "disconnect", "makeCall", "endCall"]),

    // Detect country from user's timezone and pre-select in country dropdowns
    detectCountryFromTimezone() {
      try {
        // Get browser timezone
        const browserTimeZone = Intl.DateTimeFormat().resolvedOptions()
          .timeZone;

        if (!browserTimeZone) {
          console.warn("[Welcome] Could not detect timezone");
          return;
        }

        console.log("[Welcome] Detected timezone:", browserTimeZone);

        // Get browser UTC offset (in minutes)
        const browserOffset = moment.tz(browserTimeZone).utcOffset();

        console.log("[Welcome] Browser UTC Offset:", browserOffset);

        // Find country by matching offset instead of timezone name
        const matchedCountry = this.countryList.find((country) => {
          const zones = moment.tz.zonesForCountry(country.code);

          if (!zones) return false;

          return zones.some((zone) => {
            const zoneOffset = moment.tz(zone).utcOffset();
            return zoneOffset === browserOffset;
          });
        });

        if (matchedCountry) {
          console.log(
            "[Welcome] Auto-selected country:",
            matchedCountry.code,
            "based on offset:",
            browserOffset,
          );

          this.callingFromCountry = matchedCountry.code;
          this.callingToCountry = matchedCountry.code;
        } else {
          console.log("[Welcome] No country found for offset:", browserOffset);
        }
      } catch (error) {
        console.warn("[Welcome] Could not detect timezone:", error);
      }
    },

    // Cloud Dialer Methods for First Call Step
    async connectCloudDialer() {
      try {
        this.cloudDialerConnecting = true;
        await this.connect();
        this.snackbar = true;
        this.snackbarText = "Connected to cloud dialer successfully!";
        this.color = "success";
      } catch (error) {
        console.error("Failed to connect cloud dialer:", error);
        this.snackbar = true;
        this.snackbarText = error.message || "Failed to connect to dialer";
        this.color = "error";
      } finally {
        this.cloudDialerConnecting = false;
      }
    },

    async disconnectCloudDialer() {
      try {
        await this.disconnect();
        this.snackbar = true;
        this.snackbarText = "Disconnected from cloud dialer";
        this.color = "info";
      } catch (error) {
        console.error("Failed to disconnect cloud dialer:", error);
      }
    },

    async makeCloudTestCall() {
      if (!this.cloudDialerNumber.trim()) {
        this.snackbar = true;
        this.snackbarText = "Please enter a phone number";
        this.color = "warning";
        return;
      }

      try {
        await this.makeCall({
          targetNumber: this.cloudDialerNumber.trim(),
          audioElement: this.$refs.cloudDialerAudio,
        });
        this.snackbar = true;
        this.snackbarText = "Call initiated successfully!";
        this.color = "success";
      } catch (error) {
        console.error("Failed to make call:", error);
        this.snackbar = true;
        this.snackbarText = error.message || "Failed to place call";
        this.color = "error";
      }
    },

    async endCloudTestCall() {
      try {
        await this.endCall();
        // Mark first call as completed
        this.cloudFirstCallMade = true;
        this.snackbar = true;
        this.snackbarText = "Test call completed! You can now proceed.";
        this.color = "success";
      } catch (error) {
        console.error("Failed to end call:", error);
      }
    },

    formatCallDuration(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },

    // Auto-select calling type based on country recommendation
    autoSelectCallingType() {
      if (this.isSameCountryCalling) {
        this.selectedCallingType = "sim";
      } else if (this.isInternationalCalling) {
        this.selectedCallingType = "cloud";
      }
    },

    // Scroll stepper header to show the active step (for mobile)
    scrollToActiveStep() {
      const stepperHeader = document.querySelector(
        ".fts-dialog .v-stepper__header",
      );
      if (!stepperHeader) return;

      const activeStep = stepperHeader.querySelector(
        ".v-stepper__step--active",
      );
      if (!activeStep) return;

      // Calculate scroll position to center the active step
      const headerRect = stepperHeader.getBoundingClientRect();
      const stepRect = activeStep.getBoundingClientRect();
      const scrollLeft =
        activeStep.offsetLeft - headerRect.width / 2 + stepRect.width / 2;

      stepperHeader.scrollTo({
        left: Math.max(0, scrollLeft),
        behavior: "smooth",
      });
    },

    // Get country name from code
    getCountryName(code) {
      const country = this.countryList.find((c) => c.code === code);
      return country ? country.name : code;
    },

    handleCallingTypeSelection() {
      // Both cloud and SIM go to step 4 now (shifted by 1 due to new Countries step)
      // Cloud: Step 4 = Cloud Provider Selection
      // SIM: Step 4 = Add Contact
      this.e1 = 4;
    },

    // Handle Step 5 continue - goes to SIP Trunk step for Twilio, or Add Contact for Own
    handleStep4Continue() {
      if (this.cloudProviderType === "twilio") {
        // Go to SIP Trunk step (step 6)
        this.e1 = 6;
        // Fetch trunks if we don't have them yet
        if (
          !this.twilioElasticTrunks ||
          this.twilioElasticTrunks.length === 0
        ) {
          this.refreshElasticTrunks();
        } else if (
          this.twilioElasticTrunks.length > 0 &&
          !this.selectedTrunkSid
        ) {
          // Auto-select the first trunk
          this.selectedTrunkSid = this.twilioElasticTrunks[0].sid;
        }
      } else {
        // Own SIP provider - skip trunk step, go to Add Contact (step 8)
        this.e1 = 8;
      }
    },

    // Refresh Elastic SIP Trunks from Twilio
    async refreshElasticTrunks() {
      console.log("[SIP Trunk] refreshElasticTrunks called");
      this.trunkRefreshing = true;
      this.trunkLoading =
        !this.twilioElasticTrunks || this.twilioElasticTrunks.length === 0;
      this.trunkError = null;
      this.trunkSuccess = null;

      try {
        console.log("[SIP Trunk] Fetching elastic trunks from API...");
        const response = await this.$http.post(
          `${this.ENDPOINT}/pbx/list-elastic-trunks`,
          {
            companyId: this.$store.state.user.companyId,
          },
        );

        console.log("[SIP Trunk] API response:", response.body);
        const result = response.body;
        if (result && result.trunks) {
          this.twilioElasticTrunks = result.trunks;
          console.log(
            "[SIP Trunk] Found trunks:",
            this.twilioElasticTrunks.length,
          );
          console.log("[SIP Trunk] Trunk details:", this.twilioElasticTrunks);

          // Auto-select first trunk if none selected
          if (this.twilioElasticTrunks.length > 0 && !this.selectedTrunkSid) {
            this.selectedTrunkSid = this.twilioElasticTrunks[0].sid;
            console.log(
              "[SIP Trunk] Auto-selected first trunk:",
              this.selectedTrunkSid,
            );
          }

          this.snackbar = true;
          this.snackbarText = `Found ${this.twilioElasticTrunks.length} SIP trunk(s)`;
          this.color = "success";
        }
      } catch (err) {
        console.error("[SIP Trunk] Error fetching elastic trunks:", err);
        console.error("[SIP Trunk] Error details:", err.body || err.message);
        this.trunkError =
          err.body && err.body.error
            ? err.body.error.message
            : "Failed to fetch SIP trunks. Please try again.";
      } finally {
        this.trunkLoading = false;
        this.trunkRefreshing = false;
        console.log("[SIP Trunk] refreshElasticTrunks completed");
      }
    },

    // Create a new Elastic SIP Trunk
    async createNewElasticTrunk() {
      console.log("[SIP Trunk] createNewElasticTrunk called");
      console.log("[SIP Trunk] Trunk name:", this.newTrunkName);

      if (!this.newTrunkName) {
        this.trunkError = "Please enter a trunk name";
        console.log("[SIP Trunk] Error: No trunk name provided");
        return;
      }

      this.trunkCreating = true;
      this.trunkError = null;
      this.trunkSuccess = null;

      try {
        const companyId = this.$store.state.user.companyId;

        // Generate credentials for this trunk
        this.trunkCredentialUsername = `godial_${companyId.substring(0, 8)}`;
        this.trunkCredentialPassword = this.generateRandomPassword();

        console.log("[SIP Trunk] Generated credentials:", {
          username: this.trunkCredentialUsername,
          passwordLength: this.trunkCredentialPassword.length,
          pbxServerIp: this.pbxServerIp,
        });

        // Step 1: Create new trunk via API
        console.log("[SIP Trunk] Step 1: Creating new trunk via API...");
        const response = await this.$http.post(
          `${this.ENDPOINT}/pbx/create-elastic-trunk`,
          {
            companyId: companyId,
            trunkName: this.newTrunkName,
          },
        );

        console.log("[SIP Trunk] Create trunk API response:", response.body);
        const result = response.body;

        if (!result || !result.trunk) {
          throw new Error("Failed to create trunk - no trunk returned");
        }

        const newTrunk = result.trunk;
        console.log("[SIP Trunk] New trunk created:", newTrunk.sid);

        // Add the new trunk to the list and select it
        this.twilioElasticTrunks.push(newTrunk);
        this.selectedTrunkSid = newTrunk.sid;

        // Step 2: Configure trunk with credentials and IP ACL
        console.log(
          "[SIP Trunk] Step 2: Configuring trunk credentials and IP ACL...",
        );
        const credentialResponse = await this.$http.post(
          `${this.ENDPOINT}/pbx/configure-trunk-credentials`,
          {
            companyId: companyId,
            trunkSid: newTrunk.sid,
            credentialUsername: this.trunkCredentialUsername,
            credentialPassword: this.trunkCredentialPassword,
            pbxServerIp: this.pbxServerIp,
          },
        );

        console.log(
          "[SIP Trunk] Credential configuration response:",
          credentialResponse.body,
        );

        if (!credentialResponse.body || !credentialResponse.body.ok) {
          var errMsg =
            credentialResponse.body && credentialResponse.body.error
              ? credentialResponse.body.error
              : "Failed to configure trunk credentials";
          throw new Error(errMsg);
        }

        console.log(
          "[SIP Trunk] ✅ Credentials and IP ACL configured successfully",
        );

        // Step 3: Save the trunk configuration
        console.log("[SIP Trunk] Step 3: Saving trunk configuration...");
        const saveResponse = await this.$http.post(
          `${this.ENDPOINT}/pbx/save-trunk-configuration?companyId=${companyId}`,
          {
            carrier: {
              type: "twilio-elastic-trunk",
              trunkSid: newTrunk.sid,
              trunkName: newTrunk.friendlyName,
              domainName: newTrunk.domainName,
              accountSid: this.twilioAccountInfo
                ? this.twilioAccountInfo.accountSid
                : null,
              credentialUsername: this.trunkCredentialUsername,
              credentialPassword: this.trunkCredentialPassword,
              pbxServerIp: this.pbxServerIp,
              register: false, // Twilio Elastic SIP Trunks don't need REGISTER
            },
            dids: [],
          },
        );

        console.log(
          "[SIP Trunk] Save trunk configuration response:",
          saveResponse.body,
        );

        if (saveResponse.body && saveResponse.body.ok) {
          // Clear the form
          this.newTrunkName = "";

          this.trunkSuccess =
            "SIP Trunk created and configured successfully with credentials and IP ACL!";
          this.snackbar = true;
          this.snackbarText = "SIP Trunk created and configured for GoDial!";
          this.color = "success";

          console.log(
            "[SIP Trunk] ✅ Trunk created and configuration saved successfully",
          );

          // Update the twilioCarrier
          this.twilioCarrier = {
            type: "twilio-elastic-trunk",
            trunkSid: newTrunk.sid,
            credentialUsername: this.trunkCredentialUsername,
          };
          
          // Refresh PBX data in Vuex store to update dialer visibility
          await this.$store.dispatch('refreshPbxData');

          // Proceed to next step and load phone numbers
          console.log("[SIP Trunk] Proceeding to step 7...");
          setTimeout(() => {
            this.e1 = 7;
            this.refreshPhoneNumbers();
          }, 1500);
        } else {
          var saveErrMsg =
            saveResponse.body && saveResponse.body.error
              ? saveResponse.body.error
              : "Failed to save trunk configuration";
          throw new Error(saveErrMsg);
        }
      } catch (err) {
        console.error("[SIP Trunk] Error creating elastic trunk:", err);
        console.error("[SIP Trunk] Error details:", err.body || err.message);
        this.trunkError =
          err.body && err.body.error
            ? err.body.error.message
            : err.message || "Failed to create SIP trunk. Please try again.";
      } finally {
        this.trunkCreating = false;
        console.log("[SIP Trunk] createNewElasticTrunk completed");
      }
    },

    // Generate a random password for SIP credentials
    generateRandomPassword(length = 16) {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%";
      let result = "";
      for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return result;
    },

    // Use the selected trunk for GoDial
    async useSelectedTrunk() {
      console.log("[SIP Trunk] useSelectedTrunk called");
      console.log("[SIP Trunk] Selected trunk SID:", this.selectedTrunkSid);

      if (!this.selectedTrunkSid) {
        this.trunkError = "Please select a trunk";
        console.log("[SIP Trunk] Error: No trunk selected");
        return;
      }

      this.trunkConfiguring = true;
      this.trunkError = null;
      this.trunkSuccess = null;

      try {
        // Find the selected trunk details
        const selectedTrunk = this.twilioElasticTrunks.find(
          (t) => t.sid === this.selectedTrunkSid,
        );
        console.log("[SIP Trunk] Selected trunk details:", selectedTrunk);

        if (!selectedTrunk) {
          this.trunkError = "Selected trunk not found";
          console.log("[SIP Trunk] Error: Selected trunk not found in list");
          this.trunkConfiguring = false;
          return;
        }

        // Generate credentials for this trunk
        const companyId = this.$store.state.user.companyId;
        this.trunkCredentialUsername = `godial_${companyId.substring(0, 8)}`;
        this.trunkCredentialPassword = this.generateRandomPassword();

        console.log("[SIP Trunk] Generated credentials:", {
          username: this.trunkCredentialUsername,
          passwordLength: this.trunkCredentialPassword.length,
          pbxServerIp: this.pbxServerIp,
        });

        // Step 1: Configure trunk with credentials and IP ACL
        console.log(
          "[SIP Trunk] Step 1: Configuring trunk credentials and IP ACL...",
        );
        const credentialResponse = await this.$http.post(
          `${this.ENDPOINT}/pbx/configure-trunk-credentials`,
          {
            companyId: companyId,
            trunkSid: this.selectedTrunkSid,
            credentialUsername: this.trunkCredentialUsername,
            credentialPassword: this.trunkCredentialPassword,
            pbxServerIp: this.pbxServerIp,
          },
        );

        console.log(
          "[SIP Trunk] Credential configuration response:",
          credentialResponse.body,
        );

        if (!credentialResponse.body || !credentialResponse.body.ok) {
          var errMsg =
            credentialResponse.body && credentialResponse.body.error
              ? credentialResponse.body.error
              : "Failed to configure trunk credentials";
          throw new Error(errMsg);
        }

        console.log(
          "[SIP Trunk] ✅ Credentials and IP ACL configured successfully",
        );

        // Step 2: Save the trunk configuration
        console.log("[SIP Trunk] Step 2: Saving trunk configuration...");
        const response = await this.$http.post(
          `${this.ENDPOINT}/pbx/save-trunk-configuration?companyId=${companyId}`,
          {
            carrier: {
              type: "twilio-elastic-trunk",
              trunkSid: this.selectedTrunkSid,
              trunkName: selectedTrunk.friendlyName,
              domainName: selectedTrunk.domainName,
              accountSid: this.twilioAccountInfo
                ? this.twilioAccountInfo.accountSid
                : null,
              credentialUsername: this.trunkCredentialUsername,
              credentialPassword: this.trunkCredentialPassword,
              pbxServerIp: this.pbxServerIp,
              register: false, // Twilio Elastic SIP Trunks don't need REGISTER
            },
            dids: selectedTrunk.phoneNumbers || [],
          },
        );

        console.log(
          "[SIP Trunk] Save trunk configuration response:",
          response.body,
        );

        const result = response.body;
        if (result && result.ok) {
          this.trunkSuccess =
            "SIP Trunk configured successfully with credentials and IP ACL!";
          this.snackbar = true;
          this.snackbarText = "SIP Trunk configured for GoDial!";
          this.color = "success";

          console.log("[SIP Trunk] ✅ Trunk configuration saved successfully");

          // Update the twilioCarrier
          this.twilioCarrier = {
            type: "twilio-elastic-trunk",
            trunkSid: this.selectedTrunkSid,
            credentialUsername: this.trunkCredentialUsername,
          };
          
          // Refresh PBX data in Vuex store to update dialer visibility
          await this.$store.dispatch('refreshPbxData');

          // Proceed to next step and load phone numbers
          console.log("[SIP Trunk] Proceeding to step 7...");
          setTimeout(() => {
            this.e1 = 7;
            this.refreshPhoneNumbers();
          }, 1500);
        } else {
          var saveErrMsg =
            result && result.error
              ? result.error
              : "Failed to save trunk configuration";
          throw new Error(saveErrMsg);
        }
      } catch (err) {
        console.error("[SIP Trunk] ❌ Error configuring trunk:", err);
        console.error("[SIP Trunk] Error details:", err.body || err.message);
        this.trunkError =
          err.body && err.body.error
            ? err.body.error.message
            : err.message || "Failed to configure trunk. Please try again.";
      } finally {
        this.trunkConfiguring = false;
        console.log("[SIP Trunk] Configuration process completed");
      }
    },

    // ====== Step 6: Phone Numbers & DID Configuration Methods ======

    async refreshPhoneNumbers() {
      console.log("[Phone Numbers] Refreshing phone numbers...");
      this.phoneNumbersRefreshing = true;
      this.phoneNumbersError = null;

      try {
        const companyId = this.$store.state.user.companyId;

        // Fetch all phone numbers from Twilio account
        const response = await this.$http.get(
          `${this.ENDPOINT}/pbx/twilio-phone-numbers?companyId=${companyId}`,
        );

        console.log("[Phone Numbers] Response:", response.body);

        if (response.body && response.body.ok) {
          this.twilioPhoneNumbers = response.body.phoneNumbers || [];

          // Pre-select numbers that are already assigned to the selected trunk
          // Using trunkSid from each phone number in the response
          if (this.selectedTrunkSid) {
            this.selectedPhoneNumbers = this.twilioPhoneNumbers
              .filter((p) => p.trunkSid === this.selectedTrunkSid)
              .map((p) => p.phoneNumber);

            // Also populate trunkPhoneNumbers for reference
            this.trunkPhoneNumbers = this.twilioPhoneNumbers.filter(
              (p) => p.trunkSid === this.selectedTrunkSid,
            );
          }

          console.log(
            "[Phone Numbers] Loaded:",
            this.twilioPhoneNumbers.length,
            "numbers",
          );
          console.log(
            "[Phone Numbers] Pre-selected (on trunk):",
            this.selectedPhoneNumbers.length,
          );
        } else {
          throw new Error(
            response.body.error || "Failed to fetch phone numbers",
          );
        }
      } catch (err) {
        console.error("[Phone Numbers] Error:", err);
        var errMsg = "Failed to load phone numbers";
        if (err && err.body && err.body.error && err.body.error.message) {
          errMsg = err.body.error.message;
        } else if (err && err.message) {
          errMsg = err.message;
        }
        this.phoneNumbersError = errMsg;
      } finally {
        this.phoneNumbersRefreshing = false;
      }
    },

    isNumberAssignedToTrunk(phoneNumber) {
      // Check if this number's trunkSid matches the selected trunk
      var number = this.twilioPhoneNumbers.find(function(p) {
        return p.phoneNumber === phoneNumber;
      });
      return number && number.trunkSid === this.selectedTrunkSid;
    },

    async assignNumberToTrunk(phoneNumber) {
      console.log("[Phone Numbers] Assigning number to trunk:", phoneNumber);

      try {
        const companyId = this.$store.state.user.companyId;

        const response = await this.$http.post(
          `${this.ENDPOINT}/pbx/assign-phone-to-trunk`,
          {
            companyId: companyId,
            trunkSid: this.selectedTrunkSid,
            phoneNumber: phoneNumber,
          },
        );

        if (response.body && response.body.ok) {
          // Add to trunk numbers list
          const phoneObj = this.twilioPhoneNumbers.find(
            (p) => p.phoneNumber === phoneNumber,
          );
          if (phoneObj) {
            this.trunkPhoneNumbers.push(phoneObj);
          }

          // Add to selected if not already
          if (!this.selectedPhoneNumbers.includes(phoneNumber)) {
            this.selectedPhoneNumbers.push(phoneNumber);
          }

          this.snackbar = true;
          this.snackbarText = "Phone number assigned to trunk successfully";
          this.color = "success";
        } else {
          throw new Error(response.body.error || "Failed to assign number");
        }
      } catch (err) {
        console.error("[Phone Numbers] Assign error:", err);
        this.snackbar = true;
        var assignErrMsg = "Failed to assign number to trunk";
        if (err && err.body && err.body.error && err.body.error.message) {
          assignErrMsg = err.body.error.message;
        } else if (err && err.message) {
          assignErrMsg = err.message;
        }
        this.snackbarText = assignErrMsg;
        this.color = "error";
      }
    },

    async savePhoneNumbersConfig() {
      console.log("[Phone Numbers] Saving phone numbers configuration...");
      this.phoneNumbersSaving = true;
      this.phoneNumbersError = null;
      this.phoneNumbersSuccess = null;

      try {
        const companyId = this.$store.state.user.companyId;

        // Auto-assign any selected numbers that are not yet connected to the trunk
        for (const phoneNumber of this.selectedPhoneNumbers) {
          const phoneObj = this.twilioPhoneNumbers.find(
            (p) => p.phoneNumber === phoneNumber
          );
          // If number is not connected to this trunk, assign it first
          if (phoneObj && phoneObj.trunkSid !== this.selectedTrunkSid) {
            console.log("[Phone Numbers] Auto-assigning number to trunk:", phoneNumber);
            try {
              const assignResponse = await this.$http.post(
                `${this.ENDPOINT}/pbx/assign-phone-to-trunk`,
                {
                  companyId: companyId,
                  trunkSid: this.selectedTrunkSid,
                  phoneNumber: phoneNumber,
                }
              );
              if (!assignResponse.body || !assignResponse.body.ok) {
                throw new Error((assignResponse.body && assignResponse.body.error) || "Failed to assign number");
              }
              console.log("[Phone Numbers] Number assigned successfully:", phoneNumber);
            } catch (assignErr) {
              console.error("[Phone Numbers] Failed to assign number:", assignErr);
              throw new Error(`Failed to assign ${phoneNumber} to trunk`);
            }
          }
        }

        // Prepare DID configurations
        const dids = this.selectedPhoneNumbers.map((phoneNumber) => {
          const phoneObj = this.twilioPhoneNumbers.find(
            (p) => p.phoneNumber === phoneNumber,
          );
          return {
            number: phoneNumber,
            normalizedNumber: phoneNumber.replace(/[^0-9+]/g, ""),
            description: phoneObj ? phoneObj.friendlyName : "",
            routing: {
              type: this.defaultRoutingType,
              agentId: null,
              agentIds: [],
              fallback: "voicemail",
            },
          };
        });

        console.log("[Phone Numbers] DIDs to save:", dids);

        // Save DID configuration
        const response = await this.$http.post(
          `${this.ENDPOINT}/pbx/save-did-configuration?companyId=${companyId}`,
          {
            dids: dids,
            trunkSid: this.selectedTrunkSid,
          },
        );

        console.log("[Phone Numbers] Save response:", response.body);

        if (response.body && response.body.ok) {
          this.phoneNumbersSuccess = "Phone numbers configured successfully!";
          this.snackbar = true;
          this.snackbarText = "Phone numbers saved!";
          this.color = "success";

          // Proceed to next step (Add Contact - step 8)
          setTimeout(() => {
            this.e1 = 8;
          }, 1000);
        } else {
          throw new Error(
            response.body.error || "Failed to save DID configuration",
          );
        }
      } catch (err) {
        console.error("[Phone Numbers] Save error:", err);
        var saveErrMsg = "Failed to save configuration";
        if (err && err.body && err.body.error && err.body.error.message) {
          saveErrMsg = err.body.error.message;
        } else if (err && err.message) {
          saveErrMsg = err.message;
        }
        this.phoneNumbersError = saveErrMsg;
      } finally {
        this.phoneNumbersSaving = false;
      }
    },

    handleCloudProviderSelection() {
      if (!this.cloudProviderType) {
        this.snackbar = true;
        this.snackbarText = "Please select a provider option";
        this.color = "#c62828";
        return;
      }
      // Move to step 5 for either Twilio or Own Provider setup
      this.e1 = 5;
    },

    handleCloudSetupNext() {
      if (this.cloudProviderType === "twilio") {
        if (!this.twilioConnected) {
          this.snackbar = true;
          this.snackbarText = "Please connect your Twilio account first";
          this.color = "#c62828";
          return;
        }
      } else if (this.cloudProviderType === "own") {
        if (!this.carrierSaved) {
          this.snackbar = true;
          this.snackbarText = "Please save your carrier settings first";
          this.color = "#c62828";
          return;
        }
      }
      this.e1 = 6; // Go to Add Contact step (shifted by 1)
    },

    handleAddContactNext() {
      if (this.contactAdded) {
        if (this.selectedCallingType === "sim") {
          this.e1 = 6; // Go to First Call step for SIM (was step 5, now step 6)
        } else {
          this.e1 = 8; // Skip to Finish for Cloud (was step 7, now step 8)
        }
      } else {
        this.snackbar = true;
        this.snackbarText = "Please add a contact";
        this.color = "#c62828";
      }
    },

    // Check for Twilio Connect redirect parameters in URL (for popup callback)
    async checkTwilioConnectRedirect() {
      // Parse URL parameters - Twilio Connect redirects with AccountSid and state
      var urlParams = new URLSearchParams(window.location.search);
      var accountSid = urlParams.get("AccountSid");
      var state = urlParams.get("state");
      var error = urlParams.get("error");

      // Skip if no Twilio params in URL
      if (!accountSid && !state && !error) {
        return;
      }

      // This page was opened as a popup from Twilio Connect
      // Send the data back to the parent window via postMessage
      console.log("Twilio Connect callback detected in popup");

      // Clean up URL params
      var url = new URL(window.location.href);
      url.searchParams.delete("AccountSid");
      url.searchParams.delete("state");
      url.searchParams.delete("error");
      window.history.replaceState({}, document.title, url.pathname + url.hash);

      // If this is a popup window, send message to parent and close
      if (window.opener) {
        var messageData = {
          type: "TWILIO_CONNECT_CALLBACK",
          accountSid: accountSid,
          state: state,
          error: error,
        };
        console.log("Sending Twilio data to parent window:", messageData);
        window.opener.postMessage(messageData, "*");

        // Close the popup after a short delay
        setTimeout(function() {
          window.close();
        }, 500);
        return;
      }

      // If not in a popup (direct navigation), process normally
      // This handles the case where user manually navigates back
      if (error) {
        console.error("Twilio Connect error:", error);
        this.twilioError = "Authorization was denied: " + error;
        this.dialog = true;
        this.selectedCallingType = "cloud";
        this.cloudProviderType = "twilio";
        this.e1 = 5;
        return;
      }

      if (accountSid) {
        await this.processTwilioAccountSid(accountSid);
      }
    },

    // Process the AccountSid received from Twilio Connect OAuth
    // This just captures the AccountSid - user must provide Auth Token to complete
    async processTwilioAccountSid(accountSid) {
      console.log("Captured Twilio AccountSid from OAuth:", accountSid);

      this.dialog = true;
      this.selectedCallingType = "cloud";
      this.cloudProviderType = "twilio";
      this.e1 = 5;
      this.twilioConnecting = true;
      this.twilioError = null;

      // Store the AccountSid
      this.twilioOAuthAccountSid = accountSid;

      this.snackbar = true;
      this.snackbarText = "Account verified! Completing connection...";
      this.color = "info";

      // Automatically complete the connection (no Auth Token needed)
      try {
        var response = await this.$http.post(
          this.ENDPOINT + "/pbx/process-twilio-connect",
          {
            companyId: this.$store.state.user.companyId,
            accountSid: accountSid,
          },
        );

        var result = response.body;
        console.log("Twilio Connect processed:", result);

        if (result && result.ok && result.data) {
          this.twilioConnected = true;
          this.twilioAccountInfo = {
            accountSid: result.data.accountSid,
            friendlyName: result.data.friendlyName,
            status: result.data.status,
          };
          this.twilioPhoneNumbers = result.data.phoneNumbers || [];
          this.twilioSipDomains = result.data.sipDomains || [];
          this.twilioElasticTrunks = result.data.elasticTrunks || [];
          this.twilioNeedsSetup = result.data.needsSetup || [];
          this.twilioCarrier = result.data.carrier || null;

          // Clear OAuth state
          this.twilioOAuthAccountSid = null;

          this.snackbar = true;
          this.snackbarText = "Successfully connected to Twilio!";
          this.color = "success";
        } else {
          this.twilioError =
            "Connection succeeded but data was incomplete. Please try again.";
        }
      } catch (err) {
        console.error("Error completing Twilio connection:", err);
        this.twilioError =
          err.body && err.body.error
            ? err.body.error.message
            : "Failed to complete Twilio connection. Please try again.";
      } finally {
        this.twilioConnecting = false;
      }
    },

    // Complete Twilio connection (kept for backwards compatibility with manual connect)
    async completeTwilioOAuthConnection() {
      if (!this.twilioOAuthAccountSid) {
        this.twilioError = "No account selected. Please try connecting again.";
        return;
      }

      // Just call processTwilioAccountSid again
      await this.processTwilioAccountSid(this.twilioOAuthAccountSid);
    },

    // Twilio Connect OAuth - Opens popup for user to authorize GoDial
    async connectWithTwilioOAuth() {
      this.twilioConnecting = true;
      this.twilioError = null;

      try {
        // Get the Twilio Connect authorization URL from backend
        var response = await this.$http.get(
          this.ENDPOINT +
            "/pbx/twilio-connect-url?companyId=" +
            this.$store.state.user.companyId,
        );

        var data = response.body;

        if (!data || !data.ok || !data.authUrl) {
          throw new Error(
            (data && data.error) || "Failed to get Twilio authorization URL",
          );
        }

        console.log(
          "Opening Twilio Connect authorization popup:",
          data.authUrl,
        );

        // Open Twilio authorization in a popup window
        var width = 600;
        var height = 700;
        var left = (window.screen.width - width) / 2;
        var top = (window.screen.height - height) / 2;

        var popup = window.open(
          data.authUrl,
          "TwilioConnect",
          "width=" +
            width +
            ",height=" +
            height +
            ",left=" +
            left +
            ",top=" +
            top +
            ",resizable=yes,scrollbars=yes",
        );

        if (!popup) {
          throw new Error(
            "Popup was blocked. Please allow popups for this site and try again.",
          );
        }

        // Store reference to self for event handler
        var self = this;

        // Listen for postMessage from popup
        var messageHandler = function(event) {
          // Check if this is our Twilio callback message
          if (event.data && event.data.type === "TWILIO_CONNECT_CALLBACK") {
            console.log("Received Twilio Connect callback:", event.data);

            // Remove the event listener
            window.removeEventListener("message", messageHandler);

            // Clear the popup check interval
            if (popupCheckInterval) {
              clearInterval(popupCheckInterval);
            }

            self.twilioConnecting = false;

            if (event.data.error) {
              self.twilioError =
                "Authorization was denied: " + event.data.error;
            } else if (event.data.accountSid) {
              // Process the AccountSid
              self.processTwilioAccountSid(event.data.accountSid);
            }
          }
        };
        window.addEventListener("message", messageHandler);

        // Also check if popup was closed without completing
        var popupCheckInterval = setInterval(function() {
          if (!popup || popup.closed) {
            clearInterval(popupCheckInterval);
            window.removeEventListener("message", messageHandler);

            // Only set connecting to false if we haven't received the callback
            if (self.twilioConnecting && !self.twilioConnected) {
              self.twilioConnecting = false;
            }
          }
        }, 500);

        // Timeout after 5 minutes
        setTimeout(function() {
          clearInterval(popupCheckInterval);
          window.removeEventListener("message", messageHandler);
          if (self.twilioConnecting && !self.twilioConnected) {
            self.twilioConnecting = false;
            self.twilioError = "Authorization timed out. Please try again.";
            if (popup && !popup.closed) {
              popup.close();
            }
          }
        }, 5 * 60 * 1000);
      } catch (error) {
        console.error("Twilio OAuth error:", error);
        var errorMessage = "Failed to start Twilio authorization";
        if (error.body && error.body.error && error.body.error.message) {
          errorMessage = error.body.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }
        this.twilioError = errorMessage;
        this.twilioConnecting = false;
      }
    },

    // Twilio Manual Credentials Connect - Uses Account SID and Auth Token
    async connectWithTwilioManual() {
      if (!this.$refs.twilioManualForm.validate()) {
        return;
      }

      this.twilioConnecting = true;
      this.twilioError = null;
      this.twilioPhoneNumbers = [];

      try {
        const accountSid = this.twilioManualCredentials.accountSid.trim();
        const authToken = this.twilioManualCredentials.authToken.trim();

        // Call backend endpoint with manual credentials
        const response = await this.$http.post(
          `${this.ENDPOINT}/pbx/twilio-manual-connect`,
          {
            companyId: this.$store.state.user.companyId,
            accountSid: accountSid,
            authToken: authToken,
          },
        );

        const data = response.body;

        if (!data || !data.ok) {
          throw new Error(
            (data && data.error) || "Failed to connect with Twilio",
          );
        }

        console.log("Twilio Manual Connect success:", data);

        // Store phone numbers if available
        if (data.phoneNumbers && data.phoneNumbers.length > 0) {
          this.twilioPhoneNumbers = data.phoneNumbers;
        }

        this.twilioConnected = true;
        this.twilioConnecting = false;
        this.twilioAccountInfo = {
          accountSid: data.accountSid || accountSid,
          friendlyName: data.friendlyName || "Twilio Account",
        };

        fb.log("twilio_connected", {
          accountSid: data.accountSid,
          phoneNumbersCount:
            (data.phoneNumbers && data.phoneNumbers.length) || 0,
        });

        this.snackbar = true;
        this.snackbarText = "Twilio connected successfully!";
        this.color = "success";
      } catch (error) {
        console.error("Twilio connection error:", error);
        const errorMessage =
          (error.body && error.body.error && error.body.error.message) ||
          error.message ||
          "Failed to connect with Twilio";
        this.twilioError = errorMessage;
        this.twilioConnecting = false;
      }
    },

    async checkTwilioConnection() {
      try {
        // Check if Twilio is already configured for this company
        const response = await this.$http.get(
          `${this.ENDPOINT}/pbx?filter=${encodeURIComponent(
            JSON.stringify({
              where: { companyId: this.$store.state.user.companyId },
            }),
          )}`,
        );

        const pbxConfig = response.body && response.body[0];
        if (
          pbxConfig &&
          pbxConfig.carrier &&
          (pbxConfig.carrier.type === "twilio" ||
            pbxConfig.carrier.type === "twilio-oauth" ||
            pbxConfig.carrier.type === "twilio-connect")
        ) {
          this.twilioConnected = true;
          this.twilioAccountInfo = {
            accountSid: pbxConfig.carrier.accountSid || "Connected",
            friendlyName: pbxConfig.carrier.name || "Twilio Account",
          };

          // Load phone numbers from DIDs if available
          if (pbxConfig.dids && pbxConfig.dids.length > 0) {
            this.twilioPhoneNumbers = pbxConfig.dids.map(function(did) {
              return {
                phoneNumber: did.number,
                friendlyName: did.friendlyName,
                sid: did.twilioSid,
              };
            });
          }
        }
      } catch (error) {
        console.error("Error checking Twilio connection:", error);
      }
    },

    openTwilioSignup() {
      window.open("https://www.twilio.com/try-twilio", "_blank");
    },

    // Twilio Quick Setup - One-click setup for trunk and phone number
    async runTwilioQuickSetup() {
      if (!this.twilioQuickSetup.country) {
        this.snackbar = true;
        this.snackbarText = "Please select a country";
        this.color = "#c62828";
        return;
      }

      this.twilioQuickSetupLoading = true;
      this.twilioQuickSetupProgress = [];

      try {
        var companyId = this.$store.state.user.companyId;

        // Build request body - only include non-empty values
        var requestBody = {
          companyId: companyId,
          country: this.twilioQuickSetup.country,
          numberType: this.twilioQuickSetup.numberType || "local",
        };

        // Only add areaCode if it has a value
        if (
          this.twilioQuickSetup.areaCode &&
          this.twilioQuickSetup.areaCode.trim()
        ) {
          requestBody.areaCode = this.twilioQuickSetup.areaCode.trim();
        }

        var response = await this.$http.post(
          this.ENDPOINT + "/pbx/twilio-quick-setup",
          requestBody,
        );

        var result = response.body;

        if (result.steps) {
          this.twilioQuickSetupProgress = result.steps;
        }

        if (result.success) {
          this.snackbar = true;
          this.snackbarText = "Quick setup completed successfully!";
          this.color = "success";

          if (result.trunk) {
            this.twilioElasticTrunks = [result.trunk];
          }
          if (result.dids && result.dids.length > 0) {
            var self = this;
            this.twilioPhoneNumbers = result.dids.map(function(did) {
              return {
                sid: did.id,
                phoneNumber: did.number,
                friendlyName: did.friendlyName,
              };
            });
          }
          if (result.carrier) {
            this.twilioCarrier = result.carrier;
          }
        } else {
          this.snackbar = true;
          this.snackbarText = result.error || "Quick setup encountered issues";
          this.color = "#c62828";
        }
      } catch (error) {
        console.error("Error running quick setup:", error);
        var errorMessage =
          error.body && error.body.error
            ? error.body.error.message
            : "Failed to run quick setup";
        this.snackbar = true;
        this.snackbarText = errorMessage;
        this.color = "#c62828";
      } finally {
        this.twilioQuickSetupLoading = false;
      }
    },

    // Search for available phone numbers in Twilio
    async searchTwilioNumbers() {
      if (!this.twilioSearchParams.country) {
        this.snackbar = true;
        this.snackbarText = "Please select a country";
        this.color = "#c62828";
        return;
      }

      this.twilioSearchLoading = true;
      this.twilioSearchResults = [];

      try {
        var companyId = this.$store.state.user.companyId;
        var params = new URLSearchParams();
        params.append("companyId", companyId);
        params.append("country", this.twilioSearchParams.country);
        params.append("type", this.twilioSearchParams.type || "local");

        if (this.twilioSearchParams.areaCode) {
          params.append("areaCode", this.twilioSearchParams.areaCode);
        }
        if (this.twilioSearchParams.contains) {
          params.append("contains", this.twilioSearchParams.contains);
        }
        params.append("voiceEnabled", "true");

        var response = await this.$http.get(
          this.ENDPOINT + "/pbx/twilio-search-numbers?" + params.toString(),
        );
        var result = response.body;

        if (result.ok && result.numbers) {
          this.twilioSearchResults = result.numbers;

          if (result.numbers.length === 0) {
            this.snackbar = true;
            this.snackbarText =
              "No numbers available in this region. Try a different area code or country.";
            this.color = "info";
          }
        }
      } catch (error) {
        console.error("Error searching numbers:", error);
        var errorMsg =
          error.body && error.body.error
            ? error.body.error.message
            : "Failed to search phone numbers";
        this.snackbar = true;
        this.snackbarText = errorMsg;
        this.color = "#c62828";
      } finally {
        this.twilioSearchLoading = false;
      }
    },

    // Purchase a phone number from Twilio
    async purchaseTwilioNumber(phoneNumber) {
      var self = this;
      if (!phoneNumber) return;

      var confirmed = confirm(
        "Are you sure you want to purchase " +
          phoneNumber +
          "? This will charge your Twilio account.",
      );
      if (!confirmed) return;

      this.twilioPurchasingNumber = phoneNumber;

      try {
        var companyId = this.$store.state.user.companyId;

        var response = await this.$http.post(
          this.ENDPOINT + "/pbx/twilio-purchase-number",
          {
            companyId: companyId,
            phoneNumber: phoneNumber,
            friendlyName: "GoDial Number",
          },
        );

        var result = response.body;

        if (result.ok) {
          this.snackbar = true;
          this.snackbarText =
            "Successfully purchased " + result.number.phoneNumber + "!";
          this.color = "success";

          this.twilioPhoneNumbers.push({
            sid: result.number.sid,
            phoneNumber: result.number.phoneNumber,
            friendlyName: result.number.friendlyName,
          });

          this.twilioSearchResults = [];

          if (self.twilioElasticTrunks && self.twilioElasticTrunks.length > 0) {
            var assignConfirmed = confirm(
              "Would you like to assign this number to your SIP trunk for inbound calls?",
            );
            if (assignConfirmed) {
              await self.assignNumberToTrunk(
                result.number.sid,
                self.twilioElasticTrunks[0].sid,
              );
            }
          }
        }
      } catch (error) {
        console.error("Error purchasing number:", error);
        var purchaseError =
          error.body && error.body.error
            ? error.body.error.message
            : "Failed to purchase phone number";
        this.snackbar = true;
        this.snackbarText = purchaseError;
        this.color = "#c62828";
      } finally {
        this.twilioPurchasingNumber = null;
      }
    },

    // Assign a phone number to a SIP trunk (using SID - old method for compatibility)
    async assignNumberToTrunkBySid(phoneNumberSid, trunkSid) {
      try {
        var companyId = this.$store.state.user.companyId;

        var response = await this.$http.post(
          this.ENDPOINT + "/pbx/twilio-assign-number-to-trunk",
          {
            companyId: companyId,
            trunkSid: trunkSid,
            phoneNumberSid: phoneNumberSid,
          },
        );

        var result = response.body;

        if (result.ok) {
          this.snackbar = true;
          this.snackbarText = "Number assigned to trunk successfully!";
          this.color = "success";
        }
      } catch (error) {
        console.error("Error assigning number to trunk:", error);
        var assignError =
          error.body && error.body.error
            ? error.body.error.message
            : "Failed to assign number to trunk";
        this.snackbar = true;
        this.snackbarText = assignError;
        this.color = "#c62828";
      }
    },

    // Create an Elastic SIP Trunk in Twilio
    async createTwilioTrunk() {
      this.twilioCreatingTrunk = true;

      try {
        var companyId = this.$store.state.user.companyId;

        var response = await this.$http.post(
          this.ENDPOINT + "/pbx/twilio-create-trunk",
          {
            companyId: companyId,
            friendlyName: this.twilioTrunkName || "GoDial SIP Trunk",
          },
        );

        var result = response.body;

        if (result.ok) {
          this.snackbar = true;
          this.snackbarText = "Created SIP Trunk: " + result.trunk.friendlyName;
          this.color = "success";

          this.twilioElasticTrunks = [result.trunk];

          if (result.outboundHost) {
            this.twilioCarrier = this.twilioCarrier || {};
            this.twilioCarrier.host = result.outboundHost;
          }
        }
      } catch (error) {
        console.error("Error creating trunk:", error);
        var trunkError =
          error.body && error.body.error
            ? error.body.error.message
            : "Failed to create SIP trunk";
        this.snackbar = true;
        this.snackbarText = trunkError;
        this.color = "#c62828";
      } finally {
        this.twilioCreatingTrunk = false;
      }
    },

    // Own SIP Provider Methods
    async saveCarrierSettings() {
      if (
        !this.carrierSettings.host ||
        !this.carrierSettings.username ||
        !this.carrierSettings.password
      ) {
        this.snackbar = true;
        this.snackbarText = "Please fill in all required fields";
        this.color = "#c62828";
        return;
      }

      this.carrierSaving = true;

      try {
        const carrierConfig = {
          type: "sip",
          name: this.carrierSettings.name || "Custom SIP Provider",
          host: this.carrierSettings.host,
          port: this.carrierSettings.port || "5060",
          username: this.carrierSettings.username,
          password: this.carrierSettings.password,
          fromDomain: this.carrierSettings.fromDomain || "",
          enabled: true,
        };

        // Check if PBX config exists
        const response = await this.$http.get(
          `${this.ENDPOINT}/pbx?filter=${encodeURIComponent(
            JSON.stringify({
              where: { companyId: this.$store.state.user.companyId },
            }),
          )}`,
        );

        const existingConfig = response.body && response.body[0];

        if (existingConfig) {
          await this.$http.patch(`${this.ENDPOINT}/pbx/${existingConfig.id}`, {
            carrier: carrierConfig,
          });
        } else {
          await this.$http.post(`${this.ENDPOINT}/pbx`, {
            companyId: this.$store.state.user.companyId,
            carrier: carrierConfig,
            dids: [],
          });
        }

        this.carrierSaved = true;
        this.snackbar = true;
        this.snackbarText = "Carrier settings saved successfully!";
        this.color = "success";

        fb.log("own_carrier_configured", { host: this.carrierSettings.host });
        
        // Refresh PBX data in Vuex store to update dialer visibility
        await this.$store.dispatch('refreshPbxData');
      } catch (error) {
        console.error("Error saving carrier settings:", error);
        this.snackbar = true;
        this.snackbarText = "Failed to save carrier settings";
        this.color = "#c62828";
      } finally {
        this.carrierSaving = false;
      }
    },

    async testCarrierConnection() {
      if (!this.carrierSettings.host) {
        this.snackbar = true;
        this.snackbarText = "Please enter the SIP host first";
        this.color = "#c62828";
        return;
      }

      this.carrierTesting = true;
      this.carrierTestResult = null;

      try {
        const response = await this.$http.post(
          `${this.ENDPOINT}/pbx/test-carrier`,
          { companyId: this.$store.state.user.companyId },
        );

        const ok =
          response.body &&
          (response.body.ok ||
            (response.body.response && response.body.response.ok));
        this.carrierTestResult = ok ? "success" : "failed";

        this.snackbar = true;
        this.snackbarText = ok
          ? "Connection successful!"
          : "Connection failed. Please check your settings.";
        this.color = ok ? "success" : "#c62828";
      } catch (error) {
        console.error("Error testing carrier:", error);
        this.carrierTestResult = "failed";
        this.snackbar = true;
        this.snackbarText = "Connection test failed";
        this.color = "#c62828";
      } finally {
        this.carrierTesting = false;
      }
    },
    clickSkip() {
      this.contactAdded = true;
      this.e1 = 5;
      this.skipClicked = true;
    },
    openLink() {
      try {
        window.open("http://onelink.to/godialent", "_blank");
      } catch (e) {
        console.log(e);
      }
    },
    checkForDial() {
      this.intervalWatch = setInterval(() => {
        var filter = { fields: ["id", "ftsContactDone"] };
        this.$http
          .get(
            `${this.ENDPOINT}/companies/${
              this.$store.getters.user.companyId
            }?filter=${encodeURIComponent(JSON.stringify(filter))}`,
          )
          .then(async (response) => {
            response = response.body;
            if (response.ftsContactDone) {
              let fields = { fields: ["id", "name", "phone", "dispo"] };
              let contact = await this.$http.get(
                `${this.ENDPOINT}/contacts/${
                  this.contactAddedDetails.id
                }?filter=${encodeURIComponent(JSON.stringify(fields))}`,
              );
              contact = contact.body;
              this.contactCalled = true;
              this.contactCalledDetails = contact;
              clearInterval(this.intervalWatch);
            }
          })
          .catch((e) => {
            console.log("** Error in company first contact watcher **", e);
          });
      }, 10000);
    },
    getColor(dispo) {
      const self = this;
      if (dispo == "NEW") return "green";
      var d = _.find(self.dispoList, (d) => {
        return d.title == dispo;
      });
      if (d == undefined) {
        return "#E5E5E5";
      }
      return d.hex;
    },

    open() {
      this.dialog = true;
      fb.log("welcome_popup_opened", {
        email: this.$store.state.user.email,
        phone: this.$store.state.user.phone,
      });
      console.log(
        "this.$store.state.companyDetails",
        this.$store.state.companyDetails,
      );

      if (this.$store.state.companyDetails.sourceFrom == "whatsapp-crm") {
        this.showWhatsapp = true;
      } else {
        this.showWhatsapp = false;
      }
    },
    getFirstName() {
      return this.$store.state.user.name
        .split(" ")
        .slice(0, -1)
        .join(" ");
    },
    fts(what) {
      const self = this;
      self.dialog = false;
      self.$http
        .patch(
          `${self.$store.state.ENDPOINT}/companies/${self.$store.state.companyDetails.id}`,
          {
            ftsDone: true,
            modifiedOn: new Date(),
          },
        )
        .then((response) => {
          response = response.body;
          if (what == "cancel") {
            fb.log("fts_no_thanks");
          } else {
            clearInterval(self.intervalWatch);
            fb.log("fts_finish");
          }
          // hit store to refresh
          self.$store.dispatch("getCompanyDetails", { companyId: response.id });
          this.$emit("refreshHome");
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    addContact() {
      var patchObj = {
        name: this.name,
        phone: validator.phoneNumberValidator(this.phone),
        secondPhone: "",
        email: "",
        companyName: "",
        note: "",
        remarks: "",
        extra: "",
        companyId: this.$store.state.user.companyId,
        listId: this.defaultList,
        accountsId: "",
        smsSent: false,
        emailSent: false,
        linkSent: false,
        appSent: false,
        customFields: [],
        ftsContact: true,
      };

      this.$http
        .post(`${this.ENDPOINT}/contacts`, patchObj)
        .then((response) => {
          this.contactAddedDetails = response.body;
          //this.$swal({ type: "success", text: "Successful" });
          this.contactAdded = true;
          // Pre-populate the cloud dialer number with the contact's phone
          this.cloudDialerNumber = response.body.phone || this.phone;
          this.checkForDial();
          // Navigation happens via button click, not here
        })
        .catch((err) => {
          if (err.body.error && err.body.error.message) {
            if (err.body.error.message.includes("is not unique")) {
              this.$swal({
                type: "error",
                text: "This phone number already exists in this list",
              });
            } else if (err.body.error.message.includes("is not valid")) {
              this.$swal({
                type: "error",
                text: "Enter a phone number",
              });
            } else {
              this.$swal({ type: "error", text: err.body.error.message });
            }

            return;
          }

          this.$swal({
            type: "error",
            text: "Error while adding this contact",
          });
        });
    },
  },
};
</script>
<style scoped>
/* ============================================
   DESIGN SYSTEM - PROFESSIONAL & COMPACT
   ============================================ */
:root {
  --primary-color: #37cf37;
  --primary-light: rgba(55, 207, 55, 0.1);
  --primary-dark: #2db82d;
  --text-dark: #2c3e50;
  --text-muted: #5a6c7d;
  --border-light: #e8ecef;
  --bg-subtle: #f8fafb;
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 20px;
}

/* Modern Stepper Styles */
.modern-stepper {
  box-shadow: none !important;
  background: #fff !important;
  border-radius: var(--radius-xl) !important;
  overflow: hidden;
}

.modern-stepper-header {
  box-shadow: none !important;
  background: linear-gradient(180deg, #f8fafb 0%, #fff 100%) !important;
  padding: 16px 20px 12px !important;
  border-bottom: 1px solid var(--border-light);
}

.step-label {
  font-size: 11px !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: var(--text-muted);
}

/* Modern Typography - Compact */
.modern-h1 {
  font-size: 26px;
  font-weight: 700;
  color: var(--text-dark);
  line-height: 1.3;
  letter-spacing: -0.3px;
}

.modern-h2 {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-dark);
}

.modern-h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-dark);
}

.modern-p {
  font-size: 14px;
  line-height: 1.6;
  color: var(--text-muted);
  margin-bottom: 0;
}

/* Card Styles - Rounded & Compact */
.welcome-card,
.choice-card,
.contact-card,
.call-card,
.finish-card,
.setup-card {
  background: #fff;
  border-radius: 0 !important;
}

.avatar-shadow {
  box-shadow: var(--shadow-md);
  border: 3px solid #fff;
}

.feature-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.feature-chips .v-chip {
  font-size: 11px !important;
  height: 26px !important;
  border-radius: 50px !important;
}

/* Calling Option Cards - Compact & Rounded */
.calling-option-card {
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1.5px solid var(--border-light) !important;
  border-radius: var(--radius-lg) !important;
  background: #fff !important;
  position: relative;
  overflow: hidden;
}

.calling-option-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: transparent;
  transition: all 0.25s ease;
}

.calling-option-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-lg) !important;
  border-color: var(--primary-color) !important;
}

.calling-option-card:hover::before {
  background: var(--primary-color);
}

/* Selected Card - Highly Visible */
.selected-card {
  border: 2.5px solid var(--primary-color) !important;
  background: linear-gradient(
    135deg,
    rgba(55, 207, 55, 0.08) 0%,
    rgba(55, 207, 55, 0.15) 100%
  ) !important;
  box-shadow: 0 0 0 4px rgba(55, 207, 55, 0.15),
    0 8px 24px rgba(55, 207, 55, 0.2) !important;
  transform: translateY(-2px);
}

.selected-card::before {
  background: linear-gradient(
    90deg,
    var(--primary-color),
    var(--primary-dark)
  ) !important;
  height: 5px !important;
}

.selected-card::after {
  content: "✓";
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: #37cf37;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 4px 12px rgba(55, 207, 55, 0.5);
  animation: checkmark-pop 0.3s ease-out;
  z-index: 10;
  border: 2px solid #fff;
}

@keyframes checkmark-pop {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.selected-card .option-title {
  color: var(--primary-dark) !important;
}

.selected-card .option-icon-wrapper .v-icon {
  transform: scale(1.1);
}

.option-icon-wrapper {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.option-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--text-dark);
}

.option-description {
  font-size: 13px;
  color: var(--text-muted);
  line-height: 1.5;
}

.feature-text {
  font-size: 12px !important;
  color: var(--text-muted) !important;
}

/* Form Card - Rounded */
.modern-form-card {
  border-radius: var(--radius-lg) !important;
  border: 1px solid var(--border-light) !important;
  box-shadow: var(--shadow-sm) !important;
}

/* Twilio Form Card */
.twilio-form-card {
  border-radius: var(--radius-lg) !important;
  border: 1px solid var(--border-light) !important;
  max-width: 480px;
  margin: 0 auto;
}

.twilio-form-card .v-text-field--outlined fieldset {
  border-radius: var(--radius-sm) !important;
}

.twilio-form-card .section-header {
  background: rgba(242, 47, 70, 0.08);
}

.twilio-form-card .section-title {
  color: #f22f46;
}

/* QR Card - Rounded */
.qr-card {
  border-radius: var(--radius-lg) !important;
  border: 1px solid var(--border-light) !important;
}

.qr-image {
  border-radius: var(--radius-md);
  border: 1px solid var(--border-light);
}

/* List Styles - Compact & Rounded */
.modern-list-text {
  font-size: 13px !important;
  color: var(--text-dark) !important;
  font-weight: 500;
}

.modern-list-item {
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md) !important;
  margin-bottom: 8px;
  padding: 10px 14px !important;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
}

.modern-list-item:hover {
  background: var(--bg-subtle) !important;
  border-color: var(--primary-color);
  transform: translateX(4px);
}

.modern-list-title {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--text-dark) !important;
}

.next-steps-list .v-list-item__subtitle {
  font-size: 12px !important;
  color: var(--text-muted) !important;
}

/* Waiting & Complete Sections */
.waiting-section,
.call-complete-section {
  margin-top: 12px;
}

.waiting-section .v-card {
  border-radius: var(--radius-md) !important;
}

.call-details {
  font-size: 13px;
}

/* Section Headers - Compact */
.section-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: var(--bg-subtle);
  border-radius: var(--radius-sm);
  margin-bottom: 12px;
}

.section-title {
  font-weight: 600;
  font-size: 12px;
  color: var(--primary-dark);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Content Section - Rounded */
.content-section {
  padding: 16px;
  background: var(--bg-subtle);
  border-radius: var(--radius-md);
  border: 1px solid var(--border-light);
}

/* Gradient Background - Subtle */
.gradient-bg {
  position: relative;
  background: linear-gradient(
    135deg,
    #f8fafb 0%,
    #fff 50%,
    #f0fdf4 100%
  ) !important;
}

/* Decorative Circles - Subtle */
.decorative-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.4;
  pointer-events: none;
}

.decorative-circle.circle-1 {
  top: -30px;
  right: -30px;
  width: 120px;
  height: 120px;
  background: radial-gradient(
    circle,
    rgba(55, 207, 55, 0.08) 0%,
    transparent 70%
  );
}

.decorative-circle.circle-2 {
  bottom: -40px;
  left: -40px;
  width: 150px;
  height: 150px;
  background: radial-gradient(
    circle,
    rgba(55, 207, 55, 0.06) 0%,
    transparent 70%
  );
}

.decorative-circle.circle-3 {
  top: 50%;
  right: 10%;
  width: 80px;
  height: 80px;
  background: radial-gradient(
    circle,
    rgba(55, 207, 55, 0.05) 0%,
    transparent 70%
  );
}

/* Step Badge - Compact */
.step-badge {
  display: flex;
  justify-content: center;
}

.step-badge .v-chip {
  font-size: 10px !important;
  letter-spacing: 0.8px;
  padding: 0 10px !important;
  height: 22px !important;
  border-radius: 50px !important;
}

/* Legacy Styles (for backward compatibility) */
.p {
  font-size: 13.5px;
  margin: 0;
}

.h1 {
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 10px;
}

.custom-input {
  width: 100%;
}

.custom-chip {
  cursor: pointer;
  font-size: 0.7rem;
}

.label-head {
  margin: 0;
  font-weight: 500;
  margin-block: 0.5rem;
}

.chip-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 100%;
  overflow: hidden;
}

.green-chip {
  color: #4caf50 !important;
}

li {
  font-size: 14px;
}

/* ============================================
   CELEBRATION & CONFETTI EFFECTS
   ============================================ */
.celebration-card {
  overflow: hidden;
}

.trophy-wrapper {
  position: relative;
  display: inline-block;
}

.trophy-wrapper::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 120px;
  height: 120px;
  background: radial-gradient(
    circle,
    rgba(55, 207, 55, 0.25) 0%,
    transparent 70%
  );
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: trophy-glow 2s ease-in-out infinite;
}

.trophy-avatar {
  position: relative;
  z-index: 2;
  animation: trophy-bounce 1.5s ease-in-out infinite alternate;
  box-shadow: 0 8px 24px rgba(55, 207, 55, 0.3) !important;
}

@keyframes trophy-glow {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.4;
  }

  50% {
    transform: translate(-50%, -50%) scale(1.2);
    opacity: 0.7;
  }
}

@keyframes trophy-bounce {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-5px);
  }
}

.celebration-chip {
  animation: chip-pulse 2s ease-in-out infinite;
}

@keyframes chip-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(55, 207, 55, 0.4);
  }

  50% {
    box-shadow: 0 0 0 8px rgba(55, 207, 55, 0);
  }
}

/* Confetti Container - Green Theme */
.confetti-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.confetti {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  animation: confetti-fall 4s linear infinite;
}

.confetti:nth-child(1) {
  left: 10%;
  background: #37cf37;
  animation-delay: 0s;
  animation-duration: 3.5s;
}

.confetti:nth-child(2) {
  left: 25%;
  background: #2db82d;
  animation-delay: 0.5s;
  animation-duration: 4s;
}

.confetti:nth-child(3) {
  left: 50%;
  background: #4caf50;
  animation-delay: 1s;
  animation-duration: 3s;
}

.confetti:nth-child(4) {
  left: 70%;
  background: #66bb6a;
  animation-delay: 0.3s;
  animation-duration: 4.5s;
}

.confetti:nth-child(5) {
  left: 90%;
  background: #81c784;
  animation-delay: 0.8s;
  animation-duration: 3.8s;
}

@keyframes confetti-fall {
  0% {
    top: -10%;
    transform: translateX(0) rotate(0deg);
    opacity: 1;
  }

  100% {
    top: 100%;
    transform: translateX(100px) rotate(720deg);
    opacity: 0;
  }
}

/* Step Badge Styling */
.step-badge {
  display: flex;
  justify-content: center;
}

.step-badge .v-chip {
  font-size: 11px !important;
  letter-spacing: 1px;
  padding: 0 12px !important;
}

/* Decorative Circle Variants */
.decorative-circle.circle-3 {
  bottom: 10%;
  left: 5%;
  width: 200px;
  height: 200px;
  background: linear-gradient(
    135deg,
    rgba(17, 153, 142, 0.08) 0%,
    rgba(56, 239, 125, 0.05) 100%
  );
}

/* Enhanced Gradient Background */
.gradient-bg::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2337cf37' fill-opacity='0.015'%3E%3Cpath d='M20 20c0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10-10 10-10-4.5-10-10zM0 20c0-5.5 4.5-10 10-10s10 4.5 10 10-4.5 10-10 10S0 25.5 0 20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
  z-index: 0;
}

/* Button Styling */
.v-card-actions .v-btn {
  border-radius: var(--radius-sm) !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px !important;
  text-transform: none !important;
}

.v-card-actions {
  background: var(--bg-subtle);
  border-top: 1px solid var(--border-light);
}

/* Stepper Content Animation */
.v-stepper__content {
  animation: fadeSlideIn 0.3s ease-out;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Twilio Connect Button - Google OAuth Style */
.twilio-connect-btn {
  background: linear-gradient(135deg, #f22f46 0%, #d91c5c 100%) !important;
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  letter-spacing: 0.3px !important;
  padding: 12px 32px !important;
  border-radius: var(--radius-md) !important;
  box-shadow: 0 4px 14px rgba(242, 47, 70, 0.35) !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  text-transform: none !important;
}

.twilio-connect-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(242, 47, 70, 0.45) !important;
  background: linear-gradient(135deg, #ff3355 0%, #e52266 100%) !important;
}

.twilio-connect-btn:active {
  transform: translateY(0) !important;
  box-shadow: 0 2px 8px rgba(242, 47, 70, 0.3) !important;
}

.twilio-connect-btn .v-icon {
  margin-right: 10px !important;
}

/* Twilio link styling */
.twilio-link {
  color: #f22f46 !important;
  text-decoration: none;
  font-weight: 500;
}

.twilio-link:hover {
  text-decoration: underline;
}

/* Twilio form card styling */
.twilio-form-card {
  border-radius: var(--radius-lg) !important;
}

/* Mobile responsive for Twilio section */
@media (max-width: 600px) {
  .twilio-connect-btn {
    font-size: 13px !important;
    padding: 10px 20px !important;
  }

  .twilio-connect-btn img {
    height: 20px !important;
    margin-right: 8px !important;
  }

  .twilio-form-card {
    padding: 16px !important;
  }

  .twilio-form-card .modern-h3 {
    font-size: 18px !important;
  }

  .twilio-form-card .modern-p {
    font-size: 13px !important;
  }

  .twilio-form-card .v-expansion-panel-header {
    padding: 8px 12px !important;
    font-size: 11px !important;
  }

  .twilio-form-card .v-expansion-panel-content__wrap {
    padding: 8px !important;
  }

  .modern-h1 {
    font-size: 20px !important;
  }
}
</style>

<style>
/* ============================================
   GLOBAL STYLES (Deep Selectors)
   ============================================ */

/* Dialog Rounded Corners & Scrollable */
.fts-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  max-height: 85vh !important;
  margin: 24px !important;
}

.fts-dialog .v-stepper {
  border-radius: 20px !important;
  display: flex;
  flex-direction: column;
  max-height: calc(85vh - 48px) !important;
  overflow: hidden;
}

.fts-dialog .v-stepper__header {
  flex-shrink: 0;
}

.fts-dialog .v-stepper__items {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.fts-dialog .v-stepper__content {
  flex: 1;
  overflow: hidden !important;
  padding-bottom: 0 !important;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.fts-dialog .v-stepper__wrapper {
  height: 100%;
  overflow: hidden !important;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.fts-dialog .v-stepper__content > .v-card,
.fts-dialog .v-stepper__wrapper > .v-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.fts-dialog .v-stepper__content > .v-card > .v-card__text,
.fts-dialog .v-stepper__wrapper > .v-card > .v-card__text {
  flex: 1;
  overflow-y: auto !important;
  padding-bottom: 16px !important;
  min-height: 0;
}

.fts-dialog .v-stepper__content > .v-card > .v-card-actions,
.fts-dialog .v-stepper__wrapper > .v-card > .v-card-actions {
  flex-shrink: 0;
  background: #f8fafb;
  border-top: 1px solid #e8ecef;
  padding: 16px 24px !important;
}

/* Mobile Responsive Dialog */
@media (max-width: 600px) {
  .fts-dialog {
    margin: 8px !important;
    max-height: 95vh !important;
    border-radius: 16px !important;
  }

  .fts-dialog .v-stepper {
    max-height: calc(95vh - 16px) !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .fts-dialog .v-stepper__content {
    flex: 1 !important;
    overflow: hidden !important;
    max-height: none !important;
    padding: 12px !important;
    padding-bottom: 0 !important;
    min-height: 0 !important;
  }

  /* Mobile Stepper Header - Horizontal Scrollable, Centered */
  .fts-dialog .v-stepper__header {
    height: auto !important;
    flex-wrap: nowrap !important;
    padding: 12px 16px !important;
    flex-shrink: 0 !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    justify-content: center !important;
    gap: 0 !important;
    background: linear-gradient(180deg, #f8fafb 0%, #fff 100%) !important;
    border-bottom: 1px solid #e8ecef;
    scroll-behavior: smooth;
  }

  .fts-dialog .v-stepper__header::-webkit-scrollbar {
    display: none;
  }

  .fts-dialog .v-stepper__step {
    flex: 0 0 auto !important;
    padding: 8px 6px !important;
    min-width: auto !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .fts-dialog .v-stepper__step__step {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    margin-right: 0 !important;
    margin-bottom: 4px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  }

  /* Step labels - always visible but compact */
  .fts-dialog .step-label {
    display: block !important;
    font-size: 8px !important;
    max-width: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    color: #9e9e9e;
    margin-top: 2px;
  }

  /* Active step label highlighted */
  .fts-dialog .v-stepper__step--active .step-label {
    color: #37cf37 !important;
    font-weight: 700 !important;
  }

  /* Completed step styling */
  .fts-dialog .v-stepper__step--complete .step-label {
    color: #37cf37 !important;
  }

  /* Dividers between steps */
  .fts-dialog .v-stepper__header .v-divider {
    display: block !important;
    flex: 0 0 auto !important;
    width: 20px !important;
    min-width: 20px !important;
    max-width: 20px !important;
    margin: 0 4px !important;
    align-self: flex-start !important;
    margin-top: 18px !important;
    border-color: #e0e0e0 !important;
  }

  .fts-dialog .v-card-actions {
    flex-shrink: 0 !important;
    background: white !important;
    padding: 12px 16px !important;
    border-top: 1px solid #e8ecef !important;
  }

  /* Mobile typography adjustments */
  .fts-dialog .modern-h1 {
    font-size: 20px !important;
    line-height: 1.3 !important;
  }

  .fts-dialog .modern-h2 {
    font-size: 18px !important;
  }

  .fts-dialog .modern-h3 {
    font-size: 14px !important;
  }

  .fts-dialog .modern-p {
    font-size: 13px !important;
    line-height: 1.5 !important;
  }

  /* Mobile card padding */
  .fts-dialog .v-card__text {
    padding: 12px !important;
  }

  /* SIP Trunk Tabs - Mobile Styling */
  .fts-dialog .v-tabs {
    min-height: 44px !important;
  }

  .fts-dialog .v-tabs-bar {
    height: 44px !important;
  }

  .fts-dialog .v-tab {
    font-size: 11px !important;
    min-width: auto !important;
    padding: 0 10px !important;
    letter-spacing: 0 !important;
    text-transform: none !important;
    font-weight: 600 !important;
  }

  .fts-dialog .v-tab .v-icon {
    font-size: 16px !important;
    margin-right: 4px !important;
  }

  .fts-dialog .v-tab .v-chip {
    height: 18px !important;
    font-size: 10px !important;
    margin-left: 4px !important;
    padding: 0 6px !important;
  }

  /* SIP Trunk tab content padding */
  .fts-dialog .v-tabs-items .pa-5 {
    padding: 16px !important;
  }

  /* Trunk selection cards mobile */
  .fts-dialog .trunk-selection-card {
    margin-bottom: 10px !important;
  }

  .fts-dialog .trunk-selection-card .v-card__text {
    padding: 12px !important;
  }

  .fts-dialog .trunk-selection-card .subtitle-1 {
    font-size: 13px !important;
  }

  .fts-dialog .trunk-selection-card .caption {
    font-size: 10px !important;
    word-break: break-all;
  }

  .fts-dialog .trunk-selection-card .v-radio {
    margin-right: 8px !important;
  }

  /* Create trunk form mobile */
  .fts-dialog .v-text-field {
    font-size: 14px !important;
  }

  .fts-dialog .v-text-field--outlined .v-input__slot {
    min-height: 44px !important;
  }

  /* Mobile list items */
  .fts-dialog .v-list-item {
    min-height: 40px !important;
    padding: 0 8px !important;
  }

  .fts-dialog .modern-list-text {
    font-size: 12px !important;
  }

  /* Mobile alerts */
  .fts-dialog .v-alert {
    padding: 8px 12px !important;
    font-size: 12px !important;
  }

  /* Mobile buttons */
  .fts-dialog .v-btn:not(.v-btn--icon) {
    font-size: 12px !important;
  }

  /* Mobile form fields */
  .fts-dialog .v-text-field {
    font-size: 14px !important;
  }

  /* Mobile calling option cards */
  .fts-dialog .calling-option-card {
    margin-bottom: 12px !important;
  }

  .fts-dialog .calling-option-card .v-card__text {
    padding: 12px !important;
  }

  /* First Call step mobile adjustments */
  .fts-dialog .cloud-dialer-card {
    padding: 12px !important;
  }

  .fts-dialog .cloud-dialer-card .v-avatar {
    width: 48px !important;
    height: 48px !important;
    min-width: 48px !important;
  }

  .fts-dialog .cloud-dialer-card .v-avatar .v-icon {
    font-size: 24px !important;
  }
}

/* Extra small screens (< 400px) */
@media (max-width: 400px) {
  .fts-dialog {
    margin: 4px !important;
    max-height: 98vh !important;
    border-radius: 12px !important;
  }

  .fts-dialog .v-stepper__header {
    padding: 10px 8px !important;
  }

  .fts-dialog .v-stepper__step {
    padding: 6px 4px !important;
  }

  .fts-dialog .v-stepper__step__step {
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    font-size: 10px !important;
  }

  .fts-dialog .step-label {
    font-size: 7px !important;
    max-width: 40px !important;
  }

  .fts-dialog .v-stepper__header .v-divider {
    width: 12px !important;
    min-width: 12px !important;
    max-width: 12px !important;
    margin: 0 2px !important;
    margin-top: 16px !important;
  }

  .fts-dialog .modern-h1 {
    font-size: 18px !important;
  }

  .fts-dialog .modern-h2 {
    font-size: 16px !important;
  }

  .fts-dialog .v-card__text {
    padding: 8px !important;
  }

  .fts-dialog .v-card-actions {
    padding: 8px 12px !important;
  }

  .fts-dialog .v-btn:not(.v-btn--icon) {
    font-size: 11px !important;
    padding: 0 12px !important;
  }

  /* SIP Trunk tabs mobile */
  .fts-dialog .v-tabs {
    min-height: 40px !important;
  }

  .fts-dialog .v-tab {
    font-size: 10px !important;
    min-width: auto !important;
    padding: 0 8px !important;
    letter-spacing: 0 !important;
  }

  .fts-dialog .v-tab .v-icon {
    font-size: 14px !important;
    margin-right: 4px !important;
  }

  .fts-dialog .v-tab .v-chip {
    height: 16px !important;
    font-size: 9px !important;
    margin-left: 4px !important;
  }
}

/* Form Field Styling - Rounded */
.modern-form-card .v-text-field--outlined fieldset {
  border-radius: 10px !important;
  border-color: #e8ecef !important;
}

.modern-form-card .v-text-field--outlined:hover fieldset {
  border-color: #37cf37 !important;
}

.modern-form-card .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #37cf37 !important;
  border-width: 2px !important;
}

.modern-form-card .v-input__slot {
  border-radius: 10px !important;
}

/* Stepper Step Styling */
.modern-stepper .v-stepper__step__step {
  font-size: 12px !important;
  font-weight: 700 !important;
}

/* Chip Styling */
.calling-option-card .v-chip {
  border-radius: 50px !important;
  font-weight: 600;
  font-size: 10px !important;
}

/* Avatar in List Items */
.modern-list-item .v-list-item__avatar {
  margin-right: 12px !important;
}

/* Alert Styling - Rounded */
.v-alert {
  border-radius: 10px !important;
}

/* Fix expansion panel text field interactivity */
.v-expansion-panel-content .v-text-field {
  position: relative;
  z-index: 10;
}

.v-expansion-panel-content .v-text-field input {
  pointer-events: auto !important;
}

/* Trunk Tabs Styles */
.trunk-tabs {
  border-bottom: 1px solid #e0e0e0;
}

.trunk-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
}

.trunk-tab .tab-text {
  margin-left: 4px;
}

/* Mobile trunk tabs */
@media (max-width: 600px) {
  .trunk-tabs .v-tab {
    font-size: 12px !important;
    padding: 0 12px !important;
    min-width: 0 !important;
  }

  .trunk-tabs .v-tab .v-icon {
    font-size: 16px !important;
    margin-right: 4px !important;
  }

  .trunk-count-chip {
    height: 16px !important;
    font-size: 9px !important;
    padding: 0 4px !important;
  }

  .trunk-main-card .pa-5 {
    padding: 12px !important;
  }

  .trunk-selection-card .v-card__text {
    padding: 10px !important;
  }

  .trunk-selection-card .subtitle-1 {
    font-size: 13px !important;
    line-height: 1.3 !important;
  }

  .trunk-selection-card .caption {
    font-size: 9px !important;
    word-break: break-all !important;
    line-height: 1.3 !important;
  }

  .trunk-selection-card .v-radio {
    margin-right: 8px !important;
  }

  .trunk-selection-card .d-flex.align-center {
    flex-wrap: nowrap;
  }

  .trunk-selection-card .flex-grow-1 {
    min-width: 0;
    overflow: hidden;
  }
}

@media (max-width: 400px) {
  .trunk-tabs .v-tab {
    font-size: 11px !important;
    padding: 0 8px !important;
  }

  .trunk-tabs .v-tab .v-icon {
    font-size: 14px !important;
  }

  .trunk-tabs .tab-text {
    max-width: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* Phone Number Card Styles */
.phone-number-card {
  border-radius: 12px !important;
  transition: all 0.2s ease;
}

.phone-number-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

.phone-number-card.selected-number {
  border-color: var(--v-primary-base) !important;
  background-color: rgba(55, 207, 55, 0.05) !important;
}

.phone-number-card .min-width-0 {
  min-width: 0;
}

.phone-number-card .phone-number-text {
  word-break: break-all;
}

.phone-number-card .phone-status-chip {
  font-size: 10px !important;
}

/* Mobile Phone Number Card */
@media (max-width: 600px) {
  .phone-number-card .v-card__text {
    padding: 12px !important;
  }

  .phone-number-card .phone-number-text {
    font-size: 14px !important;
  }

  .phone-number-card .phone-status-chip {
    font-size: 9px !important;
    height: 18px !important;
  }

  .phone-number-card .assign-btn {
    font-size: 10px !important;
    padding: 0 8px !important;
  }

  .phone-number-card .caption {
    font-size: 10px !important;
  }
}

@media (max-width: 400px) {
  .phone-number-card .phone-number-text {
    font-size: 13px !important;
  }

  .phone-number-card .phone-status-chip {
    font-size: 8px !important;
    height: 16px !important;
    padding: 0 4px !important;
  }

  .phone-number-card .assign-btn {
    font-size: 9px !important;
  }
}

/* Trunk Selection Card Styles */
.trunk-selection-card {
  transition: all 0.2s ease;
  border: 2px solid transparent !important;
}

.trunk-selection-card:hover {
  border-color: var(--v-primary-lighten3) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

.selected-trunk-card {
  border-color: var(--v-primary-base) !important;
  box-shadow: 0 4px 12px rgba(55, 207, 55, 0.15) !important;
}

/* Country Selection Card Styles */
.country-select-card {
  border-radius: var(--radius-lg) !important;
  transition: all 0.2s ease;
  border: 1px solid var(--border-light) !important;
}

.country-select-card:hover {
  border-color: var(--primary-color) !important;
  box-shadow: var(--shadow-md) !important;
}

.country-autocomplete .v-text-field--outlined fieldset {
  border-radius: 10px !important;
}

/* Recommended Chip Animation */
.recommended-chip {
  animation: pulse-chip 2s ease-in-out infinite;
}

/* Recommended Chip in Top Left Corner */
.recommended-chip-corner {
  position: absolute !important;
  top: 12px;
  left: 12px;
  z-index: 2;
  animation: pulse-chip 2s ease-in-out infinite;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3) !important;
}

@keyframes pulse-chip {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(76, 175, 80, 0);
  }
}

/* Recommendation Alert */
.recommendation-alert {
  border-radius: var(--radius-md) !important;
  font-size: 14px;
}

.recommendation-alert strong {
  color: inherit;
}
</style>
